<template>
    
    <div class="transaction">
        <Toaster />
      <Header :mainHeader="true"/>
  
      <section id="transaction-products" style="padding: 10px 0px !important">
        <div class="containers">
          
          <v-card
            color="grey-lighten-4"
            height="50px"
            style="width: 90vw; margin-bottom: 8px; margin-left: auto; margin-right: auto; display: block"
            rounded="0"
            flat
          >
            <v-toolbar density="compact">
            
            
            <v-toolbar-title style="font-family: Roboto; font-weight: bold; margin:0; padding:0 10px">Sales Invoices</v-toolbar-title>

            <v-spacer></v-spacer>

            <v-tooltip location="top" text="Upload Sales CSV">
            <template v-slot:activator="{ props }">
                <v-btn
                role="button"
                icon
                v-bind="props"
                @click="openUpModal"
                >
                <v-icon>mdi-upload</v-icon> <!-- Upload icon -->
                </v-btn>
            </template>
            </v-tooltip>


            <!-- Upload Modal -->
            <!-- <v-dialog v-model="showUploadModal" max-width="500px">
            <v-card>
              <v-card-title>
                <span class="headline">Upload CSV</span>
              </v-card-title>
              <v-card-subtitle>
                <v-file-input
                  v-model="file"
                  label="Select CSV file"
                  accept=".csv"
                  @change="handleFileUpload"
                ></v-file-input>
              </v-card-subtitle>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="closeUpModal">Cancel</v-btn>
                <v-btn color="primary" @click="submitFile">Upload</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog> -->

          <!-- Upload Modal -->
                <v-dialog v-model="showUploadModal" max-width="500px">
                <v-card>
                    <v-card-title>
                    <span class="headline">Upload CSV</span>
                    </v-card-title>
                    <v-card-text>
                    <!-- Download Template Button -->
                    <v-btn
                        block
                        color="secondary"
                        size="large"
                        class="mb-4"
                        @click="downloadTemplate"
                    >
                        Download Template
                    </v-btn>
                    
                    <v-file-input
                        v-model="file"
                        label="Select CSV file"
                        accept=".csv"
                        @change="handleFileUpload"
                        :placeholder="file ? file.name : 'No file selected'"
                        prepend-icon="mdi-file-upload" 
                    ></v-file-input>
                    </v-card-text>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="closeUpModal">Cancel</v-btn>
                    <v-btn color="primary" @click="submitFile" :disabled="!file">Upload</v-btn>
                    </v-card-actions>
                </v-card>
                </v-dialog>


                
                <v-tooltip location="top" text="Make A Sale">
                    <template v-slot:activator="{ props }">
                    <v-btn role="link" href="/sales/make" icon v-bind="props">
                        <v-icon>mdi-cart</v-icon>
                    </v-btn>
                    </template>
                </v-tooltip>

                <v-tooltip location="top" text="Data Tools">
                    <template v-slot:activator="{ props: tooltip }">
                    <v-menu>
                        <template v-slot:activator="{ props: menu }">
                            <v-btn icon v-bind="mergeProps(menu, tooltip)">
                                <v-icon>mdi-database-search</v-icon>
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item
                            v-for="(item, index) in dataTools"
                            :key="index"
                            :value="index"
                            >
                                <v-list-item-title style="font-family: Roboto; font-size: 13px;">
                                    <!-- <v-dialog v-if="item.title == 'Import Sale Data'" max-width="900">
                                        <template v-slot:activator="{ props: activatorProps }">
                                            <span v-bind="activatorProps">
                                                <v-icon>{{ item.icon }}</v-icon>
                                                {{ item.title }}
                                            </span>
                                            
                                        </template>
                                        <template v-slot:default="{ isActive }">
                                            <v-card style="font-family: Roboto;" title="Download the template format">
                                            
                                            <template v-slot:text>
                                                <v-card-text>
                                                <span style="display: block; color: #3A3A3D;">
                                                    Click the button below to download the format template that you'll need to
                                                    upload your sales<br /><br />
                                                    
                                                    <b>NOTE:</b> The <b>date_of_invoicing</b> should be in the format <b>DD/MM/YYYY</b>
                                                 </span>
                                                </v-card-text>
                                                <v-btn
                                                    class="text-none mb-4"
                                                    color="indigo-darken-3"
                                                    size="x-large"
                                                    variant="flat"
                                                    block
                                                    role="link"
                                                    href="https://docs.google.com/spreadsheets/d/11ZgzFTxSBEv_dC1t9QOdb5L_xlJvClf5nJBkZwQu54w/export?format=csv"
                                                    target="_blank"
                                                >
                                                    Download Template
                                                </v-btn>
                                                <hr/>
                                                
                                                <h5>Upload Sales Template</h5>
                                                <v-file-input counter label="File input" accept="text/csv" show-size></v-file-input>
                                            </template>
                                            <v-card-actions>
                                                <v-spacer></v-spacer>

                                                <v-btn
                                                text="Close Dialog"
                                                @click="isActive.value = false"
                                                ></v-btn>
                                            </v-card-actions>
                                            </v-card>
                                        </template>
                                    </v-dialog> -->
                                    <v-dialog v-if="item.title == 'Export to CSV'" max-width="900">
                                        <template v-slot:activator="{ props: activatorProps }">
                                            <span v-bind="activatorProps">
                                                <v-icon>{{ item.icon }}</v-icon>
                                                {{ item.title }}
                                            </span>
                                            
                                        </template>
                                        <template v-slot:default="{ isActive }">
                                            
                                            <v-card style="font-family: Roboto;" title="Set Configurations For your Report">
                                                
                                            <template v-slot:text>
                                                <v-card-text>
                                                <span style="display: block; color: #3A3A3D; font-size: 16px; box-sizing: content-box;">
                                                    Select the Date Range<br />
                                                    
                                                 </span>
                                                 <span style="color: #8a8a8d">
                                                    This is covers the start and end date for the report <br />
                                                 </span>
                                                </v-card-text>
                                                <div>
                                                    <span style="display: block; font-family: Roboto; font-size: 12px">Today's date is the default date</span>
                                                    <div>
                                                        <v-date-input
                                                        v-model="reportDate"
                                                        label="Select range"
                                                        max-width="368"
                                                        multiple="range"
                                                        clearable
                                                        required
                                                        ></v-date-input>
                                                    </div>
                                                    
                                                </div>
                                                <v-spacer></v-spacer>
                                                <hr/>
                                                
                                                <h5>Format The Column Names</h5>
                                                <span style="display: block; font-family: Roboto; font-size: 15px; color: #8A8A8D;">You can choose to customize the column names to suite you or leave the defaults</span>

                                                <div>
                                                    <v-text-field 
                                                        v-model="customer_name"
                                                        placeholder="custNm"
                                                        label="Customer Name Column (custNm)"
                                                        style="font-family: Roboto;"
                                                    ></v-text-field>

                                                    <v-text-field
                                                        v-model="invcNo"
                                                        placeholder="invcNo"     
                                                        label="KRA Invoice Number Column (invcNo)"
                                                        clearable
                                                        style="font-family: Roboto;"
                                                    ></v-text-field>

                                                    <v-text-field
                                                        v-model="trdInvcNo"
                                                        placeholder="trdInvcNo"
                                                        label="Trader Invoice Number Column (trdInvcNo)"
                                                        clearable
                                                        style="font-family: Roboto;"
                                                    ></v-text-field>

                                                    <v-text-field
                                                        v-model="customer_pin"
                                                        placeholder="custTin"
                                                        label="Customer Pin Column (custTin)"
                                                        clearable
                                                        style="font-family: Roboto;"
                                                    ></v-text-field>

                                                    <v-text-field
                                                        v-model="itemCount"
                                                        placeholder="totItemCnt"
                                                        label="Total Item Count Column (totItemCnt)"
                                                        clearable
                                                        style="font-family: Roboto;"
                                                    ></v-text-field>

                                                    <v-text-field
                                                        v-model="totalTaxblAmt"
                                                        placeholder="totTaxblAmt"
                                                        label="Tax Taxable Amount Column (totTaxblAmt)"
                                                        clearable
                                                        style="font-family: Roboto;"
                                                    ></v-text-field>

                                                    <v-text-field
                                                        v-model="totalTxAmt"
                                                        placeholder="totTaxAmt"
                                                        label="Total Tax Amount Column (totTaxAmt)"
                                                        clearable
                                                        style="font-family: Roboto;"
                                                    ></v-text-field>

                                                    <v-text-field
                                                        v-model="totalAmt"
                                                        placeholder="totAmt"
                                                        label="Total Amount Column (totAmt)"
                                                        clearable
                                                        style="font-family: Roboto;"
                                                    ></v-text-field>

                                                    <v-text-field
                                                        v-model="long_url"
                                                        placeholder="long_url"
                                                        label="ETIMS link Column (long_url)"
                                                        clearable
                                                        style="font-family: Roboto;"
                                                    ></v-text-field>

                                                    <v-text-field
                                                        v-model="invcStatus"
                                                        placeholder="status"
                                                        label="Invoice Status Column (status)"
                                                        clearable
                                                        style="font-family: Roboto;"
                                                    ></v-text-field>

                                                    <v-text-field
                                                        v-model="intrlData"
                                                        placeholder="intrlData"
                                                        label="KRA Internal Data Column (intrlData)"
                                                        clearable
                                                        style="font-family: Roboto;"
                                                    ></v-text-field>

                                                    <v-text-field
                                                        v-model="rcptSign"
                                                        placeholder="rcptSign"
                                                        label="KRA receipt sign Column (rcptSign)"
                                                        clearable
                                                        style="font-family: Roboto;"
                                                    ></v-text-field>

                                                    <!-- <v-text-field
                                                        v-model="sdcId"  
                                                        placeholder="sdcId"
                                                        label="SDC ID Column (sdcId)"
                                                        clearable
                                                        style="font-family: Roboto;"
                                                    ></v-text-field>

                                                    <v-text-field
                                                        v-model="sdcNo" 
                                                        placeholder="sdcNo"
                                                        label="SDC No Column (sdcNo)"
                                                        clearable
                                                        style="font-family: Roboto;"
                                                    ></v-text-field> -->
                                                    
                                                </div>
                                            </template>
                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <!-- <a-button loading style="color: white" type="primary" @click="generateReport">Export To CSV</a-button> -->
                                                <v-btn
                                                    :loading="loader"
                                                    class="flex-grow-1"
                                                    height="48"
                                                    variant="tonal"
                                                    @click="generateReport"
                                                >
                                                    Export To CSV
                                                </v-btn>
                                                <v-btn
                                                text="Exit"
                                                @click="isActive.value = false"
                                                ></v-btn>
                                            </v-card-actions>
                                            </v-card>
                                        </template>
                                    </v-dialog>
                                    <!-- <span v-else>
                                        <v-icon>{{ item.icon }}</v-icon>
                                        {{ item.title }}
                                    </span> -->
                                    
                                </v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                    </template>

                </v-tooltip>

                <v-tooltip location="top" text="Generate Reports">
                    <template v-slot:activator="{ props: tooltip }">
                        <v-menu>
                            <template v-slot:activator="{ props: menu }">
                                <v-btn icon v-bind="mergeProps(menu, tooltip)">
                                    <v-icon>mdi-file-chart</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-item @click="openReportDialog('daily')">
                                    <v-list-item-title>
                                        <v-icon>mdi-calendar-today</v-icon>
                                        Daily Report
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="openReportDialog('monthly')">
                                    <v-list-item-title>
                                        <v-icon>mdi-calendar-month</v-icon>
                                        Monthly Report
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="openReportDialog('range')">
                                    <v-list-item-title>
                                        <v-icon>mdi-calendar-range</v-icon>
                                        Date Range Report
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </template>
                </v-tooltip>

            <v-tooltip location="top" text="Clear Filters">
                <template v-slot:activator="{ props }">
                    <v-btn @click="clearFilters" icon v-bind="props">
                        <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                </template>
            </v-tooltip>
            </v-toolbar>
        </v-card>

        <v-dialog v-model="showReportDialog" max-width="600px">
            <v-card>
                <v-card-title>Generate Report</v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" v-if="reportType === 'daily'">
                            <v-date-picker v-model="reportDate" label="Select Date"></v-date-picker>
                        </v-col>
                        <v-col cols="12" v-else-if="reportType === 'monthly'">
                            <v-date-picker
                                v-model="reportDate"
                                label="Select Month"
                                type="month"
                            ></v-date-picker>
                        </v-col>
                        <!-- <v-col cols="12" v-if="reportType === 'range'">
                            <div>
                                <span style="display: block; font-family: Roboto; font-size: 12px">
                                    Select date range for your report
                                </span>
                                <div>
                                    <v-date-input
                                        v-model="reportsDateRange"
                                        label="Select range"
                                        max-width="368"
                                        range
                                        clearable
                                        required
                                        :max="new Date().toISOString().substr(0, 10)"
                                        :rules="reportsDateRangeRules"
                                    ></v-date-input>
                                </div>
                            </div>
                        </v-col> -->
                        <v-col cols="12" v-if="reportType === 'range'">
                        <div>
                            <span style="display: block; font-family: Roboto; font-size: 12px">
                            Select date range for your report
                            </span>
                            <div style="display: flex; gap: 16px;">
                            <v-date-input
                                v-model="startDate"
                                label="Start Date"
                                :max="endDate || new Date().toISOString().substr(0, 10)"
                                clearable
                                required
                                :rules="startDateRules"
                            ></v-date-input>
                            <v-date-input
                                v-model="endDate"
                                label="End Date"
                                :min="startDate"
                                :max="new Date().toISOString().substr(0, 10)"
                                clearable
                                required
                                :rules="endDateRules"
                            ></v-date-input>
                            </div>
                        </div>
                        </v-col>
                        <v-col cols="12">
                            <v-select
                                v-model="selectedReportFormat"
                                :items="reportFormats"
                                label="Report Format"
                            ></v-select>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="showReportDialog = false">Cancel</v-btn>
                    <v-btn color="primary" @click="generateReports" :loading="isGenerating">
                        Generate
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <a-table 
            :columns="columns" 
            :loading="loading" 
            class="ant-table-striped" 
            :dataSource="state.list" 
            :pagination="pagination"
            style="font-family: Roboto;" 
            @change="handleTableChange"
            bordered
            
            size="small"
        >
            <template #headerCell="{ column }">
                <template v-if="column.key === 'custNm'">
                    <span style="color: #1890ff">Name</span>
                </template>
            </template>
            <template #customFilterDropdown="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }">
                <div style="padding: 8px">
                    <a-input
                    ref="searchInput"
                    :placeholder="`Search ${column.dataIndex}`"
                    :value="selectedKeys[0]"
                    style="width: 188px; margin-bottom: 8px; display: block"
                    @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                    @pressEnter="handleSearch(selectedKeys, confirm, column.dataIndex)"
                    />
                        
                    <a-button
                        type="primary"
                        size="small"
                        style="width: 90px; margin-right: 8px"
                        @click="handleSearch(selectedKeys, confirm, column.dataIndex)"
                    >
                        <template #icon><SearchOutlined /></template>
                        Search
                    </a-button>
                    <a-button class="reset" size="small" style="width: 90px" @click="handleReset(clearFilters)">
                        Reset
                    </a-button>
                </div>
            </template>
            <template #customFilterIcon="{ filtered }">
                <search-outlined :style="{ color: filtered ? '#108ee9' : undefined }" />
            </template>
            <template #bodyCell="{ column, index, record, text }">
                <span v-if="state.searchText && state.searchedColumn === column.dataIndex">
                    <template>
                    
                    <template>{{ fragment }}</template>
                    </template>
                </span>
                <!-- <span v-if="column.dataIndex == 'status'">
                    <a-tag v-if="text == 'active'" color="green" style="display: flex; align-items: center; font-family: Roboto; font-size: 13px">
                        <template #icon>
                            <check-circle-outlined />
                        </template>
                        <span style="font-size: 13px;">Successful</span>
                    </a-tag> 
                    <a-tag v-else-if="text == 'pending'" color="blue" style="display: flex; align-items: center; font-family: Roboto; font-size: 13px">
                        <template #icon>
                            <clock-circle-outlined />
                        </template>
                        <span style="font-size: 13px;">Pending</span>
                    </a-tag>
                </span> -->

                <span v-if="column.dataIndex == 'status'">
                    <a-tag 
                        v-if="text == 'active' && record.rcptSign" 
                        color="green" 
                        style="display: flex; align-items: center; font-family: Roboto; font-size: 13px"
                    >
                        <template #icon>
                            <check-circle-outlined />
                        </template>
                        <span style="font-size: 13px;">Successful</span>
                    </a-tag>
                    <a-tag 
                        v-else-if="text == 'active' && !record.rcptSign" 
                        color="red" 
                        style="display: flex; align-items: center; font-family: Roboto; font-size: 13px"
                    >
                        <template #icon>
                            <close-circle-outlined />
                        </template>
                        <span style="font-size: 13px;">Failed</span>
                    </a-tag>
                    <a-tag 
                        v-else-if="text == 'pending'" 
                        color="blue" 
                        style="display: flex; align-items: center; font-family: Roboto; font-size: 13px"
                    >
                        <template #icon>
                            <clock-circle-outlined />
                        </template>
                        <span style="font-size: 13px;">Pending</span>
                    </a-tag>
                </span>

                <template v-if="column.dataIndex == 'action'">
                    <a-dropdown>
                        <template #overlay>
                            <a-menu @click="handleMenuClick">
                            <a-menu-item style="font-family: Roboto;" @click="openCreditEntireSaleModal(record)" key="1">Credit Entire Sale</a-menu-item>
                            <a-menu-item style="font-family: Roboto;" @click="openModal(record)" key="2">Credit Sale Items</a-menu-item>
                            <a-menu-item style="font-family: Roboto;" @click="openModalSale(record)" key="3">View Sale</a-menu-item>
                            <a-menu-item style="font-family: Roboto;" @click="generateSaleQR(record)" key="4">Generate QR</a-menu-item>
                            </a-menu>
                        </template>
                        <a-button>
                            <span style="font-family: Roboto;">Actions</span>
                            <DownOutlined />
                        </a-button>
                    </a-dropdown>
                    <!-- <button class="btn btn-primary btn-sm" style="margin-right: 10px;" @click="openModal(record)">Credit Sale</button>
                    <button class="btn btn-default btn-sm" style="margin-right: 10px; border: 1px solid #000;" @click="openModalSale(record)">View Sale</button>
                    <button class="btn btn-secondary btn-sm" style="margin-right: 10px" @click="generateSaleQR(record)">Generate QR</button> -->
                </template>
                <template v-else-if="column.dataIndex == 'no'">
                    <span style="font-size: 13px;">{{ index + 1 }}</span>
                </template>
                <template v-else-if="column.dataIndex == 'custTin'">
                    <span style="font-size: 13px;">{{ text }}</span>
                </template>
                <template v-else-if="column.dataIndex == 'invcNo'">
                    <span style="font-size: 13px;">{{ text }}</span>
                </template>
                <template v-else-if="column.dataIndex == 'trdInvcNo'">
                    <span style="font-size: 13px;">{{ text }}</span>
                </template>
                <template v-else-if="column.dataIndex == 'custNm'">
                    <span style="font-size: 13px;">{{ text }}</span>
                </template>
                <template v-else-if="column.dataIndex == 'totAmt'">
                    <span style="font-size: 13px;">{{ formatToMoney(text) }}</span>
                </template>
                <template v-else-if="column.dataIndex == 'totTaxAmt'">
                    <span style="font-size: 13px;">KES {{ formatToMoney(text) }}</span>
                </template>
                <template v-else-if="column.dataIndex == 'createdAt'">
                    <span style="font-size: 13px;">{{ formatCreatedDate(text) }}</span>
                </template>
            </template>
        </a-table>


        </div>
      </section>

      
      <div v-show="isVisible" class="modal" style="font-family: Roboto">
            <div class="modal-content">
                <h3 style="font-family:Roboto">Make a credit note of this Sale Invoice Number {{ sale.invcNo }}</h3>
                <span class="close" style="position:absolute; width: fit-content; right: 0; margin-right: 20px;" @click="closeModal">&times;</span>
                <div class="row">
                    <p>Update Customer Details</p>
                    <div class="col-md-3">
                        <label style="font-family: Roboto; font-size:15px" for="">Customer Pin</label>
                        <input style="font-family: Roboto; font-size:'10px !important'" type="text" v-model="customerPin" class="form-control">
                    </div>
                    <div class="col-md-3">
                        <label style="font-family: Roboto; font-size:15px" for="">Customer Name</label>
                        <input style="font-family: Roboto; font-size:'10px !important'" type="text" v-model="customerName" class="form-control">
                    </div>
                    <div class="col-md-3">
                        <label style="font-family: Roboto; font-size:15px" for="">Customer Email</label>
                        <input style="font-family: Roboto; font-size:'10px !important'" type="text" v-model="customerEmail" class="form-control">
                    </div>
                    <div class="col-md-3">
                        <label style="font-family: Roboto; font-size:15px" for="">Customer Mobile</label>
                        <input style="font-family: Roboto; font-size:'10px !important'" type="text" v-model="customerMobile" class="form-control">
                    </div>
                    <hr>
                    <p style="font-family: Roboto; font-size:15px">Credit Note Details</p>
                    <div class="col-md-5">
                        <label style="font-family: Roboto; font-size:15px" for="">Select Credit Note Reason</label>
                        <select v-model="status" class="form-control" style="width: 98%;" v-if="codes[11]">
                            <option v-for="(objItem) in codes[11].dtlList" v-bind:key="objItem.id" :value="objItem.cd">{{ objItem.cdNm }}</option>
                        </select>
                        <p v-else>Wait. Loading ...</p>
                    </div>
                    <div class="col-md-7">
                        <label for="">Remarks</label>
                        <input type="text" v-model="remarks" class="form-control" />
                    </div>
                
                </div>
                <table class="table table-bordered macho" style="margin-top: 20px;">
                    <thead><th>Item Name</th><th>Item Code</th><th>Qty</th><th>Price</th><th>Discount</th><th>Total</th><th>Action</th></thead>
                    <tbody>
                        <tr v-for="(saleItem) in sale.items" v-bind:key="saleItem.itemSeq">
                            <td>{{ saleItem.itemNm }}</td>
                            <td>{{ saleItem.itemCd }}</td>
                            <td><input type="number" min="0" class="form-control" v-model="saleItem.qty"></td>
                            <td><input type="number" min="0" class="form-control" v-model="saleItem.prc"></td>
                            <td>KES {{ formatToMoney(saleItem.dcAmt) }}</td>
                            <td>KES {{ formatToMoney(saleItem.totAmt) }}</td>
                            <td>
                                <button v-if="saleItem.updatedAt != 'done'" class="btn btn-primary btn-sm" @click="creditItem(saleItem)">Credit </button>
                                <button v-else class="btn btn-sm btn-warning">Done</button>
                            </td>
                        </tr>
                    </tbody>


                    <!-- <tbody>
                        <tr v-for="(saleItem) in sale.items" v-bind:key="saleItem.itemSeq">
                        <td>{{ saleItem.itemNm }}</td>
                        <td>{{ saleItem.itemCd }}</td>
                        <td><input type="number" min="0" class="form-control" :value="saleItem.qty" @input="updateSaleItem(saleItem, 'qty', $event.target.value)"></td>
                        <td><input type="number" min="0" class="form-control" :value="saleItem.prc" @input="updateSaleItem(saleItem, 'prc', $event.target.value)"></td>
                        <td>KES {{ formatToMoney(saleItem.dcAmt) }}</td>
                        <td>KES {{ formatToMoney(saleItem.totAmt) }}</td>
                        <td>
                            <button v-if="saleItem.updatedAt != 'done'" class="btn btn-primary btn-sm" @click="creditItem(saleItem)">Credit</button>
                            <button v-else class="btn btn-sm btn-warning">Done</button>
                        </td>
                        </tr>
                    </tbody> -->
                </table>

                <!-- <div style="background-color: #f2f2f2;">
                    <table style="font-family: Roboto, sans-serif" class="table table-hover">
                        <tr>
                            <td>Sub Total</td>
                            <td>{{ formatToMoney(totTaxblAmt) }}</td>
                        </tr>
                        <tr>
                            <td>Vat</td>
                            <td>{{ formatToMoney(totTaxAmt) }}</td>
                        </tr>
                        <tr>
                            <td>Total Amount</td>
                            <td>{{ formatToMoney(totAmt) }}</td>
                        </tr>
                    </table>

                </div> -->

                <div style="background-color: #f2f2f2;">
                    <table style="font-family: Roboto, sans-serif" class="table table-hover">
                        <tr>
                            <td>Sub Total</td>
                            <td>{{ formatToMoney(totTaxblAmt-totTaxAmt) }}</td>
                        </tr>
                        <tr>
                            <td>Vat</td>
                            <td>{{ formatToMoney(totTaxAmt) }}</td>
                        </tr>
                        <tr>
                            <td>Total Amount</td>
                            <td>{{ formatToMoney(totTaxblAmt) }}</td>
                        </tr>
                    </table>
                </div>
                <button class="btn-style" style="float:right; margin: 20px;" @click="creditSale" v-if="isClickCredit">Make Credit Note</button>
            </div>
        </div>

        
      <div v-show="isVisibleSale" class="modal">
            <div class="modal-content">
                <h3>Sale Invoice Number {{ selectedSale.invcNo }}</h3>
                <span class="close" style="position:absolute; width: fit-content; right: 0; margin-right: 20px;" @click="closeModalSale">&times;</span>
                <div class="row">
                    <table class="table table-hover">
                        <tbody>
                            <tr><td>Date of Transaction</td><td>{{ formatDate(selectedSale.createdAt) }}</td></tr>
                            <tr><td>Sale Total Amount</td><td>KES {{ formatToMoney(selectedSale.totAmt) }}</td></tr>
                            <tr><td>Sale Total Tax</td><td>KES {{ formatToMoney(selectedSale.totTaxAmt) }}</td></tr>
                            <tr><td>Customer Details</td><td>{{ selectedSale.custTin }} - {{ selectedSale.custNm }} </td></tr>
                            <tr><td>eTims Link:</td><td><a target="_blank" :href="getEtimsLink()" class="btn btn-default btn-sm" style="border: 1px solid #000;;">Open </a></td></tr>
                            <tr><td>Sale Items</td><td>count: {{ selectedSale.totItemCnt }}</td></tr>
                            <tr><td>No.</td><td>Item Code</td><td>Item Name</td><td>Quantity</td><td>Price</td><td>Disc</td><td>Total</td></tr>
                            <tr v-for="(item,index) in selectedSale.items" v-bind:key="item.id">
                                <td>{{ (index+1) }}</td>
                                <td>{{ item.itemCd }}</td>
                                <td>{{ item.itemNm }}</td>
                                <td>{{ item.qty }}</td>
                                <td>{{ item.prc }}</td>
                                <td>{{ item.dcAmt }}</td>
                                <td>{{ item.totAmt }}</td>
                            </tr>
                        </tbody>
                    </table>

                    <!-- <div style="display: flex; justify-content: space-between; width: 100%;">
                        <button class="btn btn-info" style="float: right; margin: 20px;" @click="creditEntireSale">Credit Entire Sale</button>
                    </div> -->

                    
                </div>
                <!-- <h3>Download Invoice </h3> -->
                <div style="display: flex; justify-content: space-between; width: 100%;">
                    <v-btn 
                        v-if="currentUser.id === 172"
                        @click="generateThermalInvoice" 
                        :style="{ 
                            backgroundColor: '#4CAF50', 
                            color: '#FFFFFF !important', 
                            fontWeight: 'bold',
                            fontSize: '16px', 
                            padding: '10px 20px', 
                            flex: 1, 
                            marginRight: '10px' 
                        }" 
                        :disabled="!selectedSale">
                        Download Bookshop Invoice
                    </v-btn>
                    <v-btn 
                        v-if="currentUser.id === 172"
                        @click="generateInvoice" 
                        :style="{ 
                            backgroundColor: '#2196F3', 
                            color: '#FFFFFF !important', 
                            fontWeight: 'bold',
                            fontSize: '16px', 
                            padding: '10px 20px', 
                            flex: 1 
                        }" 
                        :disabled="!selectedSale">
                        Download Rentals Invoice
                    </v-btn>
                </div>

                <div style="display: flex; justify-content: space-between; width: 100%;">
                    <v-btn 
                        v-if="currentUser.id === 178"
                        @click="generateRavineInvoice" 
                        :style="{ 
                            backgroundColor: '#2196F3', 
                            color: '#FFFFFF !important', 
                            fontWeight: 'bold',
                            fontSize: '16px', 
                            padding: '10px 20px', 
                            flex: 1 
                        }" 
                        :disabled="!selectedSale">
                        Download Invoice
                    </v-btn>
                </div>
                <div style="display: flex; justify-content: space-between; width: 100%;">
                    <v-btn 
                        v-if="currentUser.id === 181" 
                        @click="generateMMNInvoice" 
                        :style="{ 
                            backgroundColor: '#2196F3', 
                            color: '#FFFFFF !important', 
                            fontWeight: 'bold',
                            fontSize: '16px', 
                            padding: '10px 20px', 
                            flex: 1 
                        }" 
                        :disabled="!selectedSale">
                        Download Invoice
                    </v-btn>
                </div>

                <div style="display: flex; justify-content: space-between; width: 100%;">
                    <v-btn 
                        v-if="currentUser.id === 238" 
                        @click="generateCKInvoice" 
                        :style="{ 
                            backgroundColor: '#2196F3', 
                            color: '#FFFFFF !important', 
                            fontWeight: 'bold',
                            fontSize: '16px', 
                            padding: '10px 20px', 
                            flex: 1 
                        }" 
                        :disabled="!selectedSale">
                        Download Invoice
                    </v-btn>
                </div>
                <div style="display: flex; justify-content: space-between; width: 100%;">
                    <v-btn 
                        v-if="currentUser.id === 258" 
                        @click="generateSankuInvoice" 
                        :style="{ 
                            backgroundColor: '#2196F3', 
                            color: '#FFFFFF !important', 
                            fontWeight: 'bold',
                            fontSize: '16px', 
                            padding: '10px 20px', 
                            flex: 1 
                        }" 
                        :disabled="!selectedSale">
                        Download Invoice
                    </v-btn>
                </div>
                <!-- <div style="display: flex; justify-content: space-between; width: 100%;">
                    <v-btn 
                        @click="generatePurchaseInvoice" 
                        :style="{ 
                            backgroundColor: '#2196F3', 
                            color: '#FFFFFF !important', 
                            fontWeight: 'bold',
                            fontSize: '16px', 
                            padding: '10px 20px', 
                            flex: 1 
                        }" 
                        :disabled="!selectedSale">
                        Download GA Purchase Invoice
                    </v-btn>
                </div> -->

                <div style="display: flex; justify-content: space-between; width: 100%;">
                    <v-btn 
                        v-if="![155, 181, 178, 172, 238, 258].includes(currentUser.id)"
                        @click="generateGeneralInvoice" 
                        :style="{ 
                            backgroundColor: '#2196F3', 
                            color: '#FFFFFF !important', 
                            fontWeight: 'bold',
                            fontSize: '16px', 
                            padding: '10px 20px', 
                            flex: 1 
                        }" 
                        :disabled="!selectedSale">
                        Download Invoice
                    </v-btn>
                </div>

                <div style="display: flex; justify-content: space-between; width: 100%;">
                    <v-btn 
                        v-if="currentUser.id === 155"
                        @click="generateDigiInvoice" 
                        :style="{ 
                            backgroundColor: '#2196F3', 
                            color: '#FFFFFF !important', 
                            fontWeight: 'bold',
                            fontSize: '16px', 
                            padding: '10px 20px', 
                            flex: 1 
                        }" 
                        :disabled="!selectedSale">
                        Download Invoice
                    </v-btn>
                </div>
                
            </div>
        </div>
  
    </div>

    <!-- Add new modal for crediting entire sale -->
    <div v-show="isCreditEntireSaleVisible" class="modal">
        <div class="modal-content">
            <h3 style="font-family: Roboto">Credit Entire Sale</h3>
            <span class="close" style="position:absolute; width: fit-content; right: 0; margin-right: 20px;" @click="closeCreditEntireSaleModal">&times;</span>
            <div class="row">
                <table class="table table-hover">
                    <tbody>
                        <tr><td>Trader Invoice Number</td><td>{{ selectedSale.trdInvcNo }}</td></tr>
                        <tr><td>Invoice Number</td><td>{{ selectedSale.invcNo }}</td></tr>
                        <tr><td>Customer Name</td><td>{{ selectedSale.custNm }}</td></tr>
                        <tr><td>Customer TIN</td><td>{{ selectedSale.custTin }}</td></tr>
                        <tr><td>Total Tax Amount</td><td>KES {{ formatToMoney(selectedSale.totTaxAmt) }}</td></tr>
                        <tr><td>Total Taxable Amount</td><td>KES {{ formatToMoney(selectedSale.totTaxblAmt) }}</td></tr>
                        <tr><td>Total Amount</td><td>KES {{ formatToMoney(selectedSale.totAmt) }}</td></tr>
                    </tbody>
                </table>
            </div>
            <button class="btn-style" style="float:right; margin: 20px;" @click="creditEntireSale">Confirm Credit Note</button>
        </div>
    </div>
</template>
  
<script>

import Header from '../../components/Header';
import Swal from 'sweetalert2'
import { Toaster } from "@steveyuowo/vue-hot-toast";
import "@steveyuowo/vue-hot-toast/vue-hot-toast.css";
import "primevue/resources/themes/md-light-indigo/theme.css"
import { toRaw, reactive, ref, computed, defineComponent, watch, mergeProps } from 'vue'

import { usePagination } from "vue-request";
import { SearchOutlined, CheckCircleOutlined, DownOutlined,ClockCircleOutlined } from "@ant-design/icons-vue";
import axios from 'axios';
import { VDateInput } from 'vuetify/lib/labs/components.mjs';

import dayjs from 'dayjs';
import QRious from 'qrious';
import { jwtDecode } from 'jwt-decode';
// import html2pdf from 'html2pdf.js';
import jsPDF from 'jspdf';
import 'jspdf-autotable';



const dateFormat = 'YYYY/MM/DD';

const value4 = ref([dayjs('2015/01/01', dateFormat), dayjs('2015/01/01', dateFormat)]);


const dialog = ref(false)
const loader = ref(false)



const state = reactive({
  searchText: '',
  searchedColumn: '',
  list: [],
  total: 0,
  current: 1,
  pageSize: 0,
  totalPages: 0
});

var [tax_amount_b, taxable_amount_b] = [0, 0];


const searchInput = ref();


const queryData = async (params) => {
    
    let { page, results, custTin, custNm, invcNo, status, trdInvcNo } = params
    let offset = (page -  1) * results;
    console.log("********************************PARAMETERS**********************")
    console.log(params)
    let token = JSON.parse(localStorage.getItem('access_token'))
//    let businessName = JSON.parse(localStorage.getitem('businessName'))
//    let businessPin = JSON.parse(localStorage.getItem('businessPin'))
    // Example value with special character #
    const encodedInvcNo = encodeURIComponent(trdInvcNo);
    
    if(!custTin && !custNm && !invcNo && !status && !trdInvcNo) {
        let response = await axios.get(process.env.VUE_APP_URL + `/sales/?offset=${offset}&limit=${results}`, {
            headers: {
                "Content-Type": "application/json",
                "authorization": `Bearer ${token}`
            }
        })

        if (response) {
        window.scrollTo({
            top:0,
            behavior: "smooth"
        })
        // let resetBtns = document.getEelementsByClassName("reset")
        return response.data;
           
        }
    } else {
        
        let response = await axios.get(process.env.VUE_APP_URL + `/sales/?offset=${offset}&limit=${results}&custTin=${custTin}&custNm=${custNm}&invcNo=${invcNo}&status=${status}&trdInvcNo=${encodedInvcNo}`, {
            headers: {
                "Content-Type": "application/json",
                "authorization": `Bearer ${token}`
            }
        })

        if (response) {
        window.scrollTo({
                top:0,
                behavior: "smooth"
        })
        return response.data;
           
    }
    }
   
}


export default defineComponent ({

    name: 'SalePage',
    components: {
        SearchOutlined,
        Header,
        Toaster,
        CheckCircleOutlined,
        DownOutlined,
        ClockCircleOutlined,
        VDateInput
    },

    setup() {
        const { data, pageSize, run, current, loading } = usePagination(queryData, {
            formatResult: res => res.data,
            pagination: {
                currentKey: 'page',
                pageSizeKey: 'results',
                // totalKey: state.total,
                // totalPageKey: state.totalPages
                totalKey: 'total',
                totalPageKey: 'totalPages'
            },
            
        });

        
        const pagination = computed(() => ({
            total: state.total,
            current: current.value,
            pageSize: pageSize.value,
            showSizeChanger: true,
            showQuickJumper: true,
            pageSizeOptions: ['10', '20', '50', '100', '200']
            // totalPageKey: state.totalPages
        }))

       

        watch(data, (newValue) => {
            state.total = newValue.total
            state.list = newValue.sales
            state.pageSize = pageSize
            state.totalPages = newValue.totalPages
            
        });

    

        const handleTableChange = (pag, filters, sorter) =>{
            console.log("*********************MY ROBBINS***********************")
            console.log(filters)
            console.log(pag)
            console.log(sorter)
            run({
                results: pag.pageSize,
                page: pag?.current,
                sortField: sorter.field,
                sortOrder: sorter.order,
                ...filters,
            });
        };

        

        return {
            pageSize,
            loading,
            pagination,
            run,
            handleTableChange,
            state,
            dialog,
            value4,
            loader,
        }
    },

    data(){
        return{
            dates: [],
            dateRange: {
                startDate: new Date(),
                endDate: new Date()
            },
            options: {
                locale: {
                    format: "DD/MM/YYYY",
                    separator: " - "
                },
                alwaysShowCalendars: true
            },
            reportDate: null,
            fromDate: null,
            toDate: null,
            customer_name: null,
            invcNo: null,
            trdInvcNo: null,
            customer_pin: null,
            itemCount: null,
            txbleAmtA: null,
            txbleAmtB: null,
            txbleAmtC: null,
            txbleAmtD: null,
            txbleAmtE: null,
            txAmtA: null,
            txAmtB: null,
            txAmtC: null,
            txAmtD: null,
            txAmtE: null,
            totalTaxblAmt: null,
            totalTxAmt: null,
            totalAmt: null,
            long_url: null,
            invcStatus: null,
            intrlData: null,
            rcptSign: null,
            showUploadModal: false,
            file: null,
            showReportDialog: false,
            reportType: 'daily',
            reportsDateRange: [],
            reportsDateRangeRules: [
                v => !!v || 'Date range is required',
                v => (v && v.length === 2) || 'Please select both start and end dates'
            ],
            isGenerating: false,
            selectedReportFormat: 'summary',
            reportFormats: [
                { title: 'Summary Report', value: 'summary' },
                { title: 'Detailed Report', value: 'detailed' }
            ],
            dataTools: [
                { title: 'Export to CSV', icon: "mdi-chart-box-outline" },
            ],
            columns: computed(()=>{
              
                return [
                {
                    title: "Name",
                    dataIndex: "custNm",
                    key: "custNm",
                    customFilterDropdown: true,
                    ellipsis: true,
                    onFilter: async (value, record) => {
                        
                        record.custNm?.toString().toLowerCase().includes(value.toLowerCase()) 
                    },
                    onFilterDropdownOpenChange: visible => {
                    if (visible) {
                        setTimeout(() => {
                        searchInput?.value?.focus();
                        }, 100);
                     }
                    }
                },
                {
                    title: "Pin",
                    dataIndex: "custTin",
                    key:"custTin",
                    customFilterDropdown: true,
                    onFilter: (value, record) => record.custTin?.toString().toLowerCase().includes(value.toLowerCase()),
                    onFilterDropdownOpenChange: visible => {
                    if (visible) {
                        setTimeout(() => {
                        searchInput?.value?.focus();
                        }, 100);
                     }
                    }
                },
                {
                    title: 'Invoice No',
                    dataIndex: 'invcNo',
                    key: 'invcNo',
                    customFilterDropdown: true,
                    onFilter: (value, record) => record.invcNo?.toString().toLowerCase().includes(value.toLowerCase()),
                    onFilterDropdownOpenChange: visible => {
                    if (visible) {
                        setTimeout(() => {
                        searchInput?.value?.focus();
                        }, 100);
                     }
                    }
                },
                {
                    title: 'Trader Invoice No',
                    dataIndex: 'trdInvcNo',
                    key: 'trdInvcNo',
                    customFilterDropdown: true,
                    onFilter: (value, record) => record.trdInvcNo?.toString().toLowerCase().includes(value.toLowerCase()),
                    onFilterDropdownOpenChange: visible => {
                    if (visible) {
                        setTimeout(() => {
                        searchInput?.value?.focus();
                        }, 100);
                     }
                    }
                },
                {
                    title: "status",
                    dataIndex: "status",
                    key: "status",
                    filters: [
                        { text: 'Successful', value: 'active' },
                        { text: 'Pending', value: 'pending' },
                    ],
                },
                {
                    title: 'Amount',
                    dataIndex: 'totAmt',
                    key: 'totAmt',
                    ellipsis: true
                },
                {
                    title: 'Created At',
                    dataIndex: 'createdAt',
                    key: 'createdAt',
                    ellipsis: true
                },
                {
                    title: "Action",
                    dataIndex: "action",
                    // fixed: "right",
                    width: 120
                }

            ]
            }),
            
            count: 0,
            isLoading: true,
            token: JSON.parse(localStorage.getItem('access_token')),
            sales: [],
            isVisible:false,
            isClickCredit: true,
            isVisibleSale:false,
            codes:[],
            customerPin:"",
            selectedSale:{},
            customerName:"",
            customerEmail:"",
            customerMobile:"",
            remarks:"",
            status:"",
            reason:"",
            sale: {
                invcNo: '', 
                items: [] 
            },
            taxblAmtA: 0.00,
            taxblAmtB: 0.00,
            taxblAmtC: 0.00,
            taxblAmtD: 0.00,
            taxblAmtE: 0.00,
            taxRtA: 0,
            taxRtB: 16,
            taxRtC: 0,
            taxRtD: 0,
            taxRtE: 8,
            taxAmtA: 0,
            taxAmtB: 0,
            taxAmtC: 0,
            taxAmtD: 0,
            taxAmtE: 0,
            totTaxblAmt: 0.00,
            totTaxAmt: 0.00,
            totAmt: 0.00,
            creditItems: [],
            isSaleDataReady: false,
            currentUser: null,
            isCreditEntireSaleVisible: false,
            startDate: null,
            endDate: null,
            startDateRules: [
              v => !!v || 'Start date is required'
            ],
            endDateRules: [
                v => !!v || 'End date is required',
                v => {
                    if (!v || !this.startDate) return true;
                    // Use new Date() for robust comparison
                    return new Date(v) >= new Date(this.startDate) || 'End date must be after start date';
                }
            ]
        }
    },

    created() {
        this.getUserIdFromToken();
    },
    methods:{
        getUserIdFromToken() {
            const token = localStorage.getItem('access_token');

            if (token) {
                try {
                    const decodedtoken = jwtDecode(token);

                    this.currentUser = {
                        id: decodedtoken.sub
                    };
                } catch (error) {
                    console.error('Failed to decode token:', error);
                }
            } else {
                console.warn('No token found');
            }
        },
        downloadTemplate() {
            const templateUrl = 'https://docs.google.com/spreadsheets/d/11ZgzFTxSBEv_dC1t9QOdb5L_xlJvClf5nJBkZwQu54w/export?format=csv';
            const link = document.createElement('a');
            link.href = templateUrl;
            link.download = 'sales_template.csv';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        openUpModal() {
            this.showUploadModal = true;
        },
        closeUpModal() {
            this.showUploadModal = false;
        }, 
        handleFileUpload(event) {
        this.file = event.target.files[0];
        },

        submitFile() {
            if (this.file) {
            // Close the upload modal
            this.showUploadModal = false;

            // Show confirmation dialog
            Swal.fire({
                title: 'Confirm Upload',
                text: 'Are you sure you want to upload These Sales', 
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Yes, upload',
                cancelButtonText: 'Cancel'
            }).then((result) => {
                if (result.isConfirmed) {
                // User confirmed, proceed with upload
                this.uploadFile();
                } else {
                // User cancelled, do nothing
                console.log('Upload cancelled');
                // Optionally, you can reopen the upload modal if the user cancels
                // this.showUploadModal = true;
                }
            });
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'No File Selected',
                    text: 'Please select a file before uploading.'
                });
            }
        },

        async uploadFile() {
            this.loader = true; // Show loading indicator
            const formData = new FormData();
            formData.append('file', this.file);

            try {
            const response = await axios.post(process.env.VUE_APP_URL + '/sales/upload', formData, {
                headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${this.token}`
                }
            });

            if (response.status === 200) {
                // Success
                Swal.fire({
                icon: 'success',
                title: 'Upload Successful',
                text: 'Your file has been uploaded and processed successfully.'
                });
            } else {
                // Error
                throw new Error('Upload failed');
            }
            } catch (error) {
            console.error('Error uploading file:', error);
            Swal.fire({
                icon: 'error',
                title: 'Upload Failed',
                text: 'There was an error uploading your file. Please try again.'
            });
            } finally {
            this.loader = false; // Hide loading indicator
            this.file = null; // Reset the file input
            }
        },
    
        clearcustNm() {
            this.customer_name = ""
        },
        formatRangeDate(dateString, description) {
            let date;
            if (!dateString && description == 'fromDate') {
                date = new Date()
                date.setHours(0, 0, 0, 0)
                const localeDateString = date.toLocaleString();
                return localeDateString;
            } else if (!dateString && description == "toDate") {
                date = new Date()
                
                const localeDateString = date.toLocaleString();
                return localeDateString;
            }
            date = new Date(dateString)
            const localeDateString = date.toLocaleString();
            return localeDateString;
        },
        uploadItems(){
        this.displayUpload = "block"
        },
        closeUploadItems(){
            this.displayUpload = "none"
        },
        async generateReport() {

            this.loader = true;
            this.reportDate = this.reportDate || []
            let fromDate = this.formatRangeDate(this.reportDate[0], 'fromDate')
            let toDate = this.formatRangeDate(this.reportDate[this.reportDate.length - 1], "toDate")
            
            console.log(fromDate)
            console.log(toDate)
            try {
                let response = await axios.post(process.env.VUE_APP_URL + "/sales/excel", {
                    trdInvcNo:this.trdInvcNo,
                    invcNo:this.invcNo,
                    custTin: this.customer_pin,
                    custNm: this.customer_name,
                    totItemCnt: this.itemCount,
                    totTaxblAmt: this.totalTaxblAmt,
                    totTaxAmt: this.totalTxAmt,
                    status: this.invcStatus,
                    totAmt: this.totalAmt,
                    intrlData: this.intrlData,
                    rcptSign: this.rcptSign,
                    long_url: this.long_url,
                    sdcId: this.sdcId,
                    sdcNo: this.sdcNo,
                    fromDate,
                    toDate
                }, {
                    responseType: "blob",
                    headers: {
                        Authorization: `Bearer ${JSON.parse(localStorage.getItem('access_token'))}`,    
                    }
                })

                // Create a URL for the CSV blob
                const url = window.URL.createObjectURL(new Blob([response.data], { type: 'text/csv' }));

                // Create a link element
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'data.csv'); // Set the desired file name

                // Append the link to the body
                document.body.appendChild(link);

                // Trigger the download
                link.click();

                // Clean up and remove the link
                document.body.removeChild(link);
                this.loader = false;
                this.clearDateRangeInput()
            } catch(error) {
                console.log(error)
                return error;
            }
        },
        clearDateRangeInput() {
            this.trdInvcNo = "", this.invcNo = ""
            this.customer_pin = "", this.customer_name = ""
            this.reportDate = new Date(), this.itemCount = ""
            this.totalTaxblAmt = "", this.totalAmt = ""
            this.totalTxAmt = "",
            this.invcStatus = "", this.totalAmt = ""
            this.intrlData = "", this.rcptSign = ""
            
            this.long_url = ""
        },
        mergeProps,
        formatCreatedDate(dateString) {
            const date = new Date(dateString);
            const options = { 
                day: '2-digit', 
                month: '2-digit', 
                year: 'numeric'
            };
            const formattedDate = date.toLocaleDateString('en-GB', options);
            return formattedDate;
        },
        getEtimsLink() {
            const { selectedSale } = this;
      
            // Check if rcptSign is available
            if (selectedSale?.rcptSign) {
                return `https://etims.kra.go.ke/common/link/etims/receipt/indexEtimsReceiptData?Data=${selectedSale.Business.pin}${selectedSale.Business.bhfId}${selectedSale.rcptSign}`;
            } else {
                return selectedSale.long_url; // Replace with the link you want to use when rcptSign is not available
            }
        },
        clearFilters() {
            location.reload()
        },
        async handleSearch(selectedKeys, confirm, dataIndex) {
            console.log("MY SELECTED KEYS")
            console.log(selectedKeys)
            
            confirm();
            state.searchText = selectedKeys[0];
            state.searchedColumn = dataIndex;    
        },

        handleReset(clearFilters) {
            
            clearFilters({
                confirm: true,
            });
            state.searchText = '';
            
        },
        openModal(obj){
            console.log(obj)
            this.isVisible = true;
            this.sale = toRaw(obj);
            this.customerPin = this.sale.receipt?.custTin;
            this.customerName = this.sale.receipt?.trdeNm;
            this.customerEmail = this.sale.receipt?.custEmail;
            this.customerMobile = this.sale.receipt?.custMblNo;
        },

        openCreditEntireSaleModal(record) {
            this.selectedSale = record;
            this.isCreditEntireSaleVisible = true;
        },

        closeCreditEntireSaleModal() {
            this.isCreditEntireSaleVisible = false;
        },

        async generateSaleQR(data) {
            try {
                let response = await fetch(process.env.VUE_APP_URL + "/sales/v1/qr",{
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${this.token}`,
                        "responseType": "blob"
                    },
                    body: JSON.stringify({
                        type: "sale",
                        id: parseInt(data.id)
                    })
                })

                
                
                if (response.ok) {
                    const blob = await response.blob();
                    const filename = `invoice-${data.invcNo}.pdf`;

                    // Create a temporary link element
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = filename;

                    // Append the link to the body
                    document.body.appendChild(link);

                    // Trigger the download
                    link.click();

                    // Clean up
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(link.href);
                }                
                
        } catch(error) {
            Swal.fire({
                title: "QR Code",
                text: error.message
            })
        } 

        },
        openModalSale(obj){
            this.isVisibleSale = true;
            this.selectedSale = obj
            console.log("Selected Sale Items:", this.selectedSale.items);
        },

        formatDate (rawDate) {
            if(rawDate){
                const dateNo = new Date(rawDate)
                var minutes = 0;
                if(dateNo.getMinutes() < 10){
                minutes = "0"+dateNo.getMinutes()
                } else {
                minutes = dateNo.getMinutes()
                }
                var hours = 0;
                if(dateNo.getHours() < 10){
                hours = "0"+dateNo.getHours()
                } else {
                hours = dateNo.getHours()
                }
                return dateNo.getDate()+"/"+(dateNo.getMonth()+1)+"/"+dateNo.getFullYear()+" - "+hours+":"+minutes
            } else {
                return ""
            }
        },
        formatToMoney(value) {
            const formattedValue = Number(value).toFixed(2);
            return formattedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        closeModal() {
            this.isVisible = false;
            this.totTaxblAmt = 0;
            this.totTaxAmt = 0;
        },
        closeModalSale(){
            this.isVisibleSale = false;
        },

        // updateSaleItem(saleItem, field, value) {
        // saleItem[field] = parseFloat(value);
        // this.recalculateTotals(saleItem);
        // },
        // recalculateTotals(saleItem) {
        // saleItem.totAmt = saleItem.qty * saleItem.prc - saleItem.dcAmt;
        // },
        creditItem(saleItemObj){
            let objItem = toRaw(saleItemObj);
            console.log("LAUNCHING ITEM")
            console.log(objItem)
            this.creditItems = this.creditItems.filter(obj => obj.itemSeq !== objItem.itemSeq);
            var taxitemAmt = 0
            var taxblAmt = 0
            var itemSubTotal = this.roundToTwo(objItem.qty * objItem.prc)
            if(objItem.taxTyCd == "B"){

                if (this.currentUser.id === 155) {
                    //Trying a new implementation For Digitalent Systems tax exclusive
                    taxblAmt = this.roundToTwo(itemSubTotal / 1.16)
                    taxitemAmt = this.roundToTwo(itemSubTotal - taxblAmt)
                    this.taxblAmtB = taxblAmt
                    this.taxAmtB = taxitemAmt
                    tax_amount_b += this.roundToTwo(this.taxAmtB);
                    // changed next line to subtract tax instead of adding
                    taxable_amount_b += this.roundToTwo(this.taxblAmtB - this.taxAmtB);
                    // This is the official way it was
                    // taxable_amount_b += this.roundToTwo(this.taxblAmtB);
                    this.totAmt = this.roundToTwo(this.taxblAmtB + this.taxAmtB)
                } else {
                    taxblAmt = this.roundToTwo(itemSubTotal)
                    taxitemAmt = this.roundToTwo(itemSubTotal * 0.16)
                    this.taxblAmtB = taxblAmt
                    this.taxAmtB = taxitemAmt
                    tax_amount_b += this.roundToTwo(this.taxAmtB);
                    // changed next line to subtract tax instead of adding
                    taxable_amount_b += this.roundToTwo(this.taxblAmtB - this.taxAmtB);
                    // This is the official way it was
                    // taxable_amount_b += this.roundToTwo(this.taxblAmtB);
                    this.totAmt = this.roundToTwo(this.taxblAmtB + this.taxAmtB)

                    // This is working in test implementation but works only for single items, trouble in multiple

                    //Trying a new implementation to make sure I deduct tax from item
                    // taxblAmt = this.roundToTwo(itemSubTotal / 1.16);
                    // taxitemAmt = this.roundToTwo(itemSubTotal - taxblAmt);
                    // this.taxblAmtB = taxblAmt;
                    // this.taxAmtB = taxitemAmt;

                    // // Accumulate values globally:
                    // tax_amount_b += this.roundToTwo(this.taxAmtB);
                    // taxable_amount_b += this.roundToTwo(this.taxblAmtB);
                    // this.totTaxblAmt = this.roundToTwo(this.totTaxblAmt + taxblAmt);
                    // this.totTaxAmt = this.roundToTwo(this.totTaxAmt + taxitemAmt);

                    // console.log("Tax Amount B:", this.taxAmtB);
                    // console.log("Taxable Amount B:", this.taxblAmtB);
                    // console.log("Total Amount:", this.totAmt);


                    // const taxRate = 0.16;
                    // this.totAmt = this.roundToTwo(itemSubTotal); // itemSubTotal = total (inclusive of VAT)
                    // this.taxblAmtB = this.roundToTwo(itemSubTotal / (1 + taxRate));
                    // this.taxAmtB = this.roundToTwo(itemSubTotal - this.taxblAmtB);

                    // // Totals
                    // tax_amount_b += this.taxAmtB;
                    // taxable_amount_b += this.taxblAmtB;

                    // console.log("Tax Amount B:", this.taxAmtB);
                    // console.log("Taxable Amount B:", this.taxblAmtB);
                    // console.log("Total Amount:", this.totAmt);
                }

            } else if(objItem.taxTyCd == "E"){
                taxblAmt = this.roundToTwo(itemSubTotal)
                taxitemAmt = this.roundToTwo(itemSubTotal * 0.8)
                this.taxblAmtE = taxblAmt
                this.taxAmtE = this.roundToTwo(taxitemAmt)
                this.totAmt = this.roundToTwo(this.taxblAmtE + this.taxAmtE)
            } else {
                taxblAmt = itemSubTotal
                taxitemAmt = 0
                if(objItem.taxTyCd == "A"){
                    this.taxblAmtA = this.roundToTwo(this.taxblAmtA + itemSubTotal)
                    this.totAmt = this.roundToTwo(this.totAmt + itemSubTotal)
                } else if(objItem.taxTyCd == "C") {
                    this.taxblAmtC = this.roundToTwo(this.taxblAmtC + itemSubTotal)
                    this.totAmt = this.roundToTwo(this.totAmt + itemSubTotal)
                } else if(objItem.taxTyCd == "D") {
                    this.taxblAmtD = this.roundToTwo(this.taxblAmtD + itemSubTotal)
                    this.totAmt = this.roundToTwo(this.totAmt + itemSubTotal)
                }
                
            }

            this.totTaxblAmt = this.roundToTwo(this.totTaxblAmt + taxblAmt)
            this.totTaxAmt = this.roundToTwo(this.totTaxAmt + taxitemAmt)
            // this.totAmt = this.roundToTwo(this.totTaxblAmt + this.totTaxAmt);

        
            

            saleItemObj.updatedAt = "done";
            const obj={
                ... objItem,
                "dcRt": parseFloat(objItem.dcRt),
                "dcAmt": parseFloat(objItem.dcAmt),
                "pkg": parseFloat(objItem.qty),
                "qty": parseFloat(objItem.qty),
                "prc": parseFloat(objItem.prc),
                "splyAmt": parseFloat(itemSubTotal),
                "taxblAmt": parseFloat(taxblAmt),
                "taxAmt": parseFloat(taxitemAmt),
                "totAmt": parseFloat(this.totAmt)
            }
            this.creditItems.push(obj)
        },

    
        async creditSale () {
            this.isClickCredit = false
            const dateTimeNow = this.getCurrentDateTimeFormatted()
            const dateOnlyNow= this.getCurrentDateFormatted()

                let total_taxable_amt = this.creditItems.map(item => this.roundToTwo(item.taxblAmt)).reduce((a, b) => this.roundToTwo(a + b), 0)
                let total_tax_amt = this.creditItems.map(item => this.roundToTwo(item.taxAmt)).reduce((a, b) => this.roundToTwo(a + b), 0)
                // let overallTotAmt = this.roundToTwo(total_taxable_amt + total_tax_amt);

                // console.log("THIS IS MY TOTALS")
                // console.log("Sub Total: ", total_taxable_amt)
                // console.log("VAT", total_tax_amt)
                // console.log("Total: ", overallTotAmt)

                
                let dataSet = { 
                    "trdInvcNo": "1",
                    "invcNo": "1",
                    "orgInvcNo": this.sale.invcNo,
                    "custType":"NEW",
                    "custTin": this.customerPin,
                    "custId": this.sale.receipt?.customerId,
                    "custNm": this.customerName,
                    "custEmail": this.customerEmail,
                    "custTel": this.customerMobile,
                    "salesTyCd": "N",
                    "rcptTyCd": "R",
                    "pmtTyCd": this.sale.pmtTyCd,
                    "salesSttsCd": "02",
                    "cfmDt": dateTimeNow,
                    "salesDt": dateOnlyNow,
                    "stockRlsDt": dateTimeNow,
                    "totItemCnt": this.creditItems.length,
                    "taxblAmtA": this.taxblAmtA,
                    "taxblAmtB": taxable_amount_b,
                    "taxblAmtC": this.taxblAmtC,
                    "taxblAmtD": this.taxblAmtD,
                    "taxblAmtE": this.taxblAmtE,
                    "taxRtA": 0,
                    "taxRtB": 16,
                    "taxRtC": 0,
                    "taxRtD": 0,
                    "taxRtE": 8,
                    "taxAmtA": this.taxAmtA,
                    "taxAmtB": tax_amount_b,
                    "taxAmtC": this.taxAmtC,
                    "taxAmtD": this.taxAmtD,
                    "taxAmtE": this.taxAmtE,
                    "totTaxblAmt":  total_taxable_amt,
                    "totTaxAmt": total_tax_amt,
                    // official one
                    // "totAmt": this.roundToTwo(total_taxable_amt + total_tax_amt),
                    // my fix
                    "totAmt": this.roundToTwo(total_taxable_amt),
                    // "totAmt": this.roundToTwo(this.totAmt),
                    // "totAmt": overallTotAmt,
                    "prchrAcptcYn": "N",
                    "remark": this.remark,
                    "regrId": "Admin",
                    "regrNm": "Admin",
                    "modrId": "Admin",
                    "modrNm": "Admin",
                    "receipt": this.sale.receipt ?? {
                        "id": null,
                        "custTin": "",
                        "custMblNo": "",
                        "custEmail": null,
                        "rptNo": 1295,
                        "rcptPbctDt": "20240311",
                        "trdeNm": this.customerName,
                        "adrs": "",
                        "topMsg": "iSale POS",
                        "btmMsg": "Stanbestgroup Ltd",
                        "prchrAcptcYn": "N",
                        "status": "active",
                        "createdAt": "2024-03-11T10:12:54.687Z",
                        "updatedAt": "2024-03-11T10:12:54.687Z",
                        "deletedAt": null,
                        "customerId": null
                    },
                    "itemList": this.creditItems
                }

                console.log("THIS IS MY DATASET")
                console.log(dataSet)
                
                
                const requestOptions = {
                    method: "POST",
                    headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
                    body: JSON.stringify(dataSet)
                };
                
                const res = await fetch(process.env.VUE_APP_URL+'/credit', requestOptions)
                const data = await res.json()
                if(data.status == true){
                    Swal.fire({
                        icon: 'success',
                        title: 'Credit made successfully',
                        text: data.message
                    })
                    console.log(data)
                    this.isVisible = false
                    this.isClickCredit = true
                    location.reload()
                }else{
                    Swal.fire({
                        icon: 'error',
                        title: 'Credit not found',
                        text: data.message
                    })
                    this.isClickCredit = true
                }
        },
        convertStringToNumber(stringValue) {
            return parseFloat(stringValue);
        },
        roundToTwo(num) {
            var number = parseFloat(num);
            if (isNaN(number)) {
                return num; 
            }
            return this.convertStringToNumber(number.toFixed(2));
        },

        
        async getSales () {
            const requestOptions = {
                // method: "GET",
                headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
            };
            
            
            let res = await axios.get(process.env.VUE_APP_URL + '/sales/?limit=100&offset=0', requestOptions).then(resp=>resp.data);
            
            if(res.status == true){
                console.log("THIS IS DATA")
                console.log(res)
                this.count = res.count
                this.isLoading = false;
                this.sales = res.sales
            }else{
                this.isLoading = false;
                Swal.fire({
                    icon: 'error',
                    title: 'Sale not found',
                    text: res.message
                })
            }
        },
        async getCodes () {
            const requestOptions = {
                method: "GET",
                headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
            };
            const res = await fetch(process.env.VUE_APP_URL+'/items/pullcodes', requestOptions)
            const data = await res.json()
            this.codes = data.kraResult.clsList;
        },
        getCurrentDateFormatted() {
            const now = new Date();
            const year = now.getFullYear();
            // Get month, add 1 as getMonth() returns 0-11, and pad with zero if necessary
            const month = (now.getMonth() + 1).toString().padStart(2, '0');
            const day = now.getDate().toString().padStart(2, '0');

            return `${year}${month}${day}`;
        },
        getCurrentDateTimeFormatted() {
            const now = new Date();
            const year = now.getFullYear();
            // Get month, add 1 as getMonth() returns 0-11, and pad with zero if necessary
            const month = (now.getMonth() + 1).toString().padStart(2, '0');
            const day = now.getDate().toString().padStart(2, '0');
            const hours = now.getHours().toString().padStart(2, '0');
            const minutes = now.getMinutes().toString().padStart(2, '0');
            const seconds = now.getSeconds().toString().padStart(2, '0');

            return `${year}${month}${day}${hours}${minutes}${seconds}`;
        },

        selectSale(record) {
            this.selectedSale = record;
        },

        generateQRCode(data) {
            const qr = new QRious({
                value: data,
                size: 150 // Size of the QR code
            });
            return qr.toDataURL(); // Returns the data URL of the QR code
        },


        openReportDialog(type) {
            this.reportType = type;
            this.reportsDateRange = [];
            this.showReportDialog = true;
        },

        async creditEntireSale() {
            this.isClickCredit = false;
            const dateTimeNow = this.getCurrentDateTimeFormatted();
            const dateOnlyNow = this.getCurrentDateFormatted();

            // Create credit DTO from selected sale
            let dataSet = {
                "trdInvcNo": this.selectedSale.trdInvcNo,
                "invcNo": this.selectedSale.invcNo,
                "orgInvcNo": this.selectedSale.invcNo,
                "custType": "NEW",
                "custTin": this.selectedSale.custTin,
                "custId": this.selectedSale.receipt?.customerId,
                "custNm": this.selectedSale.custNm,
                "custEmail": this.selectedSale.receipt?.custEmail || "",
                "custTel": this.selectedSale.receipt?.custMblNo || "",
                "salesTyCd": "N",
                "rcptTyCd": "R",
                "pmtTyCd": this.selectedSale.pmtTyCd,
                "salesSttsCd": "02",
                "cfmDt": dateTimeNow,
                "salesDt": dateOnlyNow,
                "stockRlsDt": dateTimeNow,
                "totItemCnt": this.selectedSale.items.length,
                "taxblAmtA": this.selectedSale.taxblAmtA,
                "taxblAmtB": this.selectedSale.taxblAmtB,
                "taxblAmtC": this.selectedSale.taxblAmtC,
                "taxblAmtD": this.selectedSale.taxblAmtD,
                "taxblAmtE": this.selectedSale.taxblAmtE,
                "taxRtA": this.selectedSale.taxRtA,
                "taxRtB": this.selectedSale.taxRtB,
                "taxRtC": this.selectedSale.taxRtC,
                "taxRtD": this.selectedSale.taxRtD,
                "taxRtE": this.selectedSale.taxRtE,
                "taxAmtA": this.selectedSale.taxAmtA,
                "taxAmtB": this.selectedSale.taxAmtB,
                "taxAmtC": this.selectedSale.taxAmtC,
                "taxAmtD": this.selectedSale.taxAmtD,
                "taxAmtE": this.selectedSale.taxAmtE,
                "totTaxblAmt": this.selectedSale.totTaxblAmt,
                "totTaxAmt": this.selectedSale.totTaxAmt,
                "totAmt": this.selectedSale.totAmt,
                "prchrAcptcYn": "N",
                "remark": "Full Sale Credit",
                "regrId": "Admin",
                "regrNm": "Admin",
                "modrId": "Admin",
                "modrNm": "Admin",
                // "receipt": this.selectedSale.receipt,
                "receipt": this.selectedSale.receipt ?? {
                    "custTin": " ",
                    "custMblNo": " ",
                    "custEmail": " ",
                    "rptNo": 1295,
                    "rcptPbctDt": "20240311",
                    "trdeNm": this.selectedSale.custNm || " ",
                    "adrs": "",
                    "topMsg": "iSale POS",
                    "btmMsg": "Stanbestgroup Ltd",
                    "prchrAcptcYn": "N",
                },
                "itemList": this.selectedSale.items.map(item => ({
                    ...item,
                    "dcRt": parseFloat(item.dcRt),
                    "dcAmt": parseFloat(item.dcAmt),
                    "pkg": parseFloat(item.pkg),
                    "qty": parseFloat(item.qty),
                    "prc": parseFloat(item.prc),
                    "splyAmt": parseFloat(item.splyAmt),
                    "taxblAmt": parseFloat(item.taxblAmt),
                    "taxAmt": parseFloat(item.taxAmt),
                    "totAmt": parseFloat(item.totAmt)
                }))
            };

            const requestOptions = {
                method: "POST",
                headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
                body: JSON.stringify(dataSet)
            };
            
            try {
                const res = await fetch(process.env.VUE_APP_URL+'/credit', requestOptions);
                const data = await res.json();
                if(data.status == true){
                    Swal.fire({
                        icon: 'success',
                        title: 'Sale credited successfully',
                        text: data.message
                    });
                    this.isVisibleSale = false;
                    this.isClickCredit = true;
                    location.reload();
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Credit failed',
                        text: data.message
                    });
                    this.isClickCredit = true;
                }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'An error occurred while processing the credit'
                });
                this.isClickCredit = true;
            }
        },


        async generateReports() {
            this.isGenerating = true;
            try {
                const dto = {
                    type: this.reportType,
                    startDate: this.reportType === 'range' ? this.startDate : this.reportDate,
                    endDate: this.reportType === 'range' ? this.endDate : this.reportDate
                };

                let response = await axios.post(
                    `${process.env.VUE_APP_URL}/reports/sales/${this.selectedReportFormat}`,
                    dto,
                    {
                        headers: {
                            Authorization: `Bearer ${this.token}`
                        }
                    }
                );

                if (response.data) {
                    const reportData = response.data;
                    const doc = new jsPDF();
                    
                    // Add title
                    doc.setFontSize(18);
                    doc.text(
                        this.selectedReportFormat === 'summary' ? 'Sales Summary Report' : 'Detailed Sales Report',
                        20, 20
                    );

                    // Add report metadata
                    doc.setFontSize(14);
                    doc.text(`Period: ${this.reportType.charAt(0).toUpperCase() + this.reportType.slice(1)}`, 20, 30);
                    
                    // Add date range
                    const startDate = new Date(reportData.startDate).toLocaleString();
                    const endDate = new Date(reportData.endDate).toLocaleString();
                    doc.text(`Start Date: ${startDate}`, 20, 40);
                    doc.text(`End Date: ${endDate}`, 20, 50);
                    doc.text(`Generated on: ${new Date().toLocaleString()}`, 20, 60);

                    if (this.selectedReportFormat === 'summary') {
                        // Generate summary report
                        doc.autoTable({
                            startY: 70,
                            head: [['Date', 'Sales Count', 'Total Amount', 'Total Items', 'Total Tax Amount']],
                            body: reportData.summary.map(day => [
                                day.date,
                                day.salesCount.toString(),
                                day.totalAmount.toFixed(2),
                                day.totalItems.toString(),
                                day.totalTaxAmount.toFixed(2)
                            ])
                        });
                    } else {
                        // Generate detailed report
                        let currentY = 70;
                        
                        // Iterate through each sale
                        for (const sale of reportData.sales) {
                            // Sale header
                            doc.autoTable({
                                startY: currentY,
                                head: [['Date', 'Customer', 'PIN', 'Total Amount', 'Tax Amount']],
                                body: [[
                                    sale.createdAt,
                                    sale.custNm || '',
                                    sale.custTin || '',
                                    sale.totAmt.toFixed(2),
                                    sale.totTaxAmt.toFixed(2)
                                ]],
                                styles: { fillColor: [240, 240, 240] }
                            });

                            // Sale items
                            currentY = doc.lastAutoTable.finalY + 5;
                            doc.autoTable({
                                startY: currentY,
                                head: [['Item Name', 'Quantity', 'Price', 'Tax Amount', 'Total Amount']],
                                body: sale.items.map(item => [
                                    item.itemNm,
                                    item.qty.toString(),
                                    item.prc.toFixed(2),
                                    item.taxAmt.toFixed(2),
                                    item.totAmt.toFixed(2)
                                ]),
                                styles: { fontSize: 8 }
                            });

                            currentY = doc.lastAutoTable.finalY + 10;

                            // Add new page if needed
                            if (currentY > doc.internal.pageSize.height - 60) {
                                doc.addPage();
                                currentY = 20;
                            }
                        }

                        // Add summary section
                        doc.addPage();
                        doc.setFontSize(14);
                        doc.text('Summary', 20, 20);
                        
                        doc.setFontSize(12);
                        doc.text(`Total Sales: ${reportData.totalSales}`, 20, 40);
                        doc.text(`Total Amount: ${reportData.totalAmount.toFixed(2)}`, 20, 50);
                        doc.text(`Total Items: ${reportData.totalItems}`, 20, 60);
                        doc.text(`Total Tax Amount: ${reportData.totalTaxAmount.toFixed(2)}`, 20, 70);
                    }

                    // Save the PDF
                    doc.save(`sales-report-${this.reportType}-${new Date().toISOString()}.pdf`);
                    this.showReportDialog = false;
                }
            } catch (error) {
                console.error('Error generating report:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Report Generation Failed',
                    text: 'There was an error generating the report. Please try again.'
                });
            } finally {
                this.isGenerating = false;
            }
        },

        // async generateReports() {
        //     this.isGenerating = true;
        //     try {
        //         const dto = {
        //             type: this.reportType,
        //             startDate: this.reportType === 'range' ? this.reportsDateRange[0] : this.reportDate,
        //             endDate: this.reportType === 'range' ? this.reportsDateRange[1] : this.reportDate
        //         };

        //         // Get report data from API
        //         let response = await axios.post(
        //             `${process.env.VUE_APP_URL}/reports/sales/${this.selectedReportFormat}`,
        //             dto,
        //             {
        //                 headers: {
        //                     Authorization: `Bearer ${this.token}`
        //                 }
        //             }
        //         );

        //         if (response.data) {
        //             const reportData = response.data;
        //             const doc = new jsPDF();
                    
        //             // Add title
        //             doc.setFontSize(18);
        //             doc.text(
        //                 this.selectedReportFormat === 'summary' ? 'Sales Summary Report' : 'Detailed Sales Report',
        //                 20, 20
        //             );

        //             // Add report metadata
        //             doc.setFontSize(14);
        //             doc.text(`Period: ${this.reportType.charAt(0).toUpperCase() + this.reportType.slice(1)}`, 20, 30);
        //             doc.text(`Generated on: ${new Date().toLocaleString()}`, 20, 40);

        //             if (this.selectedReportFormat === 'summary') {
        //                 // Generate summary report
        //                 doc.autoTable({
        //                     startY: 50,
        //                     head: [['Date', 'Sales Count', 'Total Amount', 'Total Items', 'Total Tax Amount']],
        //                     body: reportData.summary.map(day => [
        //                         day.date,
        //                         day.salesCount.toString(),
        //                         day.totalAmount.toFixed(2),
        //                         day.totalItems.toString(),
        //                         day.totalTaxAmount.toFixed(2)
        //                     ])
        //                 });
        //             } else {
        //                 // Generate detailed report
        //                 doc.autoTable({
        //                     startY: 50,
        //                     head: [['Date', 'Customer', 'PIN', 'Items', 'Total Amount', 'Tax Amount']],
        //                     body: reportData.sales.map(sale => [
        //                         sale.createdAt,
        //                         sale.custNm || '',
        //                         sale.custTin || '',
        //                         sale.totItemCnt.toString(),
        //                         sale.totAmt.toFixed(2),
        //                         sale.totTaxAmt.toFixed(2)
        //                     ])
        //                 });

        //                 // Add summary section
        //                 const finalY = doc.lastAutoTable.finalY || 50;
        //                 doc.setFontSize(14);
        //                 doc.text('Summary', 20, finalY + 20);
                        
        //                 doc.setFontSize(12);
        //                 doc.text(`Total Sales: ${reportData.totalSales}`, 20, finalY + 30);
        //                 doc.text(`Total Amount: ${reportData.totalAmount.toFixed(2)}`, 20, finalY + 40);
        //                 doc.text(`Total Items: ${reportData.totalItems}`, 20, finalY + 50);
        //                 doc.text(`Total Tax Amount: ${reportData.totalTaxAmount.toFixed(2)}`, 20, finalY + 60);
        //             }

        //             // Save the PDF
        //             doc.save(`sales-report-${this.reportType}-${new Date().toISOString()}.pdf`);
        //             this.showReportDialog = false;
        //         }
        //     } catch (error) {
        //         console.error('Error generating report:', error);
        //         Swal.fire({
        //             icon: 'error',
        //             title: 'Report Generation Failed',
        //             text: 'There was an error generating the report. Please try again.'
        //         });
        //     } finally {
        //         this.isGenerating = false;
        //     }
        // },



        //
        //
        //
        //INVOICE

        
        generateInvoice() {
            // Check if this.sale and this.sale.items are defined
            if (!this.selectedSale || !Array.isArray(this.selectedSale.items)) {
                console.error("Sale data is not available or items are not defined.");
                return; // Exit the method if sale data is not available
            }

            const items = this.selectedSale.items.map(item => {
                const mappedItem = {
                    id: item.id,
                    name: item.itemNm, 
                    qty: Number(item.qty), 
                    price: Number(item.prc), 
                    amount: Number(item.totAmt) 
                };
                console.log("Mapped Item:", mappedItem); // Log each mapped item
                return mappedItem;
            });
            console.log("Mapped Items:", items);

            let businessSCU = JSON.parse(localStorage.getItem('businessSCU')) || ''

            const invoiceData = {
                shopName: "Catholic Diocese of Nakuru",
                shopDetails: "Moi Road\nP.O.Box-938, 20100, NAKURU",
                tillNumber: "BUY GOODS TILL: 9909363",
                invoiceTitle: "RENTAL INVOICE",
                date: this.formatDate(new Date()), // Current date
                invoiceNumber: this.selectedSale.invcNo, // Use the invoice number from the sale
                time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
                trdInvcNo: this.selectedSale.trdInvcNo,
                printDate: this.formatDate(new Date()), // Current date
                customer: this.selectedSale.custNm,
                customerTin: this.selectedSale.custTin,
                rep: "Isaiah Reg BOOKSHOP",

                batch: "B0000560",
                items: items,
                receiptSign: this.selectedSale.rcptSign,
                internalData: this.selectedSale.intrlData,
                taxable: this.selectedSale.totTaxblAmt, // Total taxable amount
                total: this.selectedSale.totAmt, // Total amount
                totalTaxAmount: this.selectedSale.totTaxAmt, // Total tax amount
                totalPaid: this.selectedSale.totAmt, // Total paid
                balance: 0, // Assuming balance is zero
                paymentMethod: "MPESA",
                qrData: this.getEtimsLink(), // Use the eTims URL for the QR code
                businessSCU: businessSCU,
            };
            console.log("INVOICE DATA:", invoiceData)


            const invoiceHTML = this.createInvoiceHTML(invoiceData);
            this.downloadInvoice(invoiceHTML, `Invoice_${invoiceData.invoiceNumber}.html`);
        },

    
        createInvoiceHTML(data) {
            const taxableAmount = Number(data.taxable) || 0;
            const totalAmount = Number(data.total) || 0;
            // const totalPaidAmount = Number(data.totalPaid) || 0;
            const totalTaxAmount = Number(data.totalTaxAmount) || 0;
            const qrCodeDataUrl = this.generateQRCode(data.qrData);
            

            return `
            <style>
                @page {
                    margin: 12mm;
                    size: A4;
                }
                .page-container {
                    width: 210mm;
                    min-height: 297mm;
                    margin: 0 auto;
                    background: white;
                    position: relative;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    padding: 18mm;
                }
                .invoice-container {
                    width: 210mm;
                    padding: 12mm;
                    background: white;
                    font-family: Arial, sans-serif;
                    color: #333;
                    line-height: 1.2;
                }
                .shop-name {
                    font-size: 28px;
                    font-weight: bold;
                    text-align: center;
                    margin-bottom: 4px;
                    color: #000;
                }
                .shop-details, .till-number {
                    font-size: 14px;
                    text-align: center;
                    margin-bottom: 3px;
                }
                .invoice-title {
                    font-size: 20px;
                    font-weight: bold;
                    text-align: center;
                    margin: 8px 0;
                    padding: 6px;
                    background-color: #f8f9fa;
                    border-radius: 6px;
                }
                .invoice-info {
                    display: flex;
                    justify-content: space-between;
                    margin: 8px 0;
                    padding: 8px;
                    background-color: #f8f9fa;
                    border-radius: 6px;
                    font-size: 14px;
                }
                .print-date {
                    font-size: 12px;
                    margin: 6px 0;
                }
                .customer-info {
                    margin: 12px 0;
                    padding: 10px;
                    border: 1px solid #ddd;
                    border-radius: 4px;
                    background-color: #fff;
                }
                .customer-info p {
                    margin: 5px 0;
                    font-size: 13px;
                }
                .items-section p {
                    font-size: 14px;
                    margin: 5px 0;
                }
                .items-table {
                    width: 100%;
                    border-collapse: collapse;
                    margin: 12px 0;
                    font-size: 14px;
                }
                .items-table th {
                    background-color: #f8f9fa;
                    padding: 10px;
                    font-weight: bold;
                    text-align: left;
                    border: 1px solid #ddd;
                }
                .items-table td {
                    padding: 8px 10px;
                    border: 1px solid #ddd;
                }
                .items-table tr:nth-child(even) {
                    background-color: #f9f9f9;
                }
                .totals-section {
                    margin-top: 12px;
                    padding: 12px;
                    border-top: 2px solid #000;
                    background-color: #f8f9fa;
                    font-size: 13px;
                }
                .totals-section p {
                    margin: 5px 0;
                }
                .total-amount {
                    font-size: 16px;
                    font-weight: bold;
                    color: #000;
                    margin: 6px 0;
                }
                .payment-info {
                    margin: 10px 0;
                    padding: 10px;
                    background-color: #f8f9fa;
                    border-radius: 4px;
                    font-size: 14px;
                }
                .payment-info p {
                    margin: 3px 0;
                }
                .qr-section {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin: 10px 0;
                    padding: 10px;
                    border: 1px solid #ddd;
                    border-radius: 4px;
                }
                .qr-section img {
                    max-width: 100px;
                    margin-right: 12px;
                }
                .qr-section div {
                    font-size: 11px;
                }
                .qr-section p {
                    margin: 5px 0;
                }
                .thank-you {
                    text-align: center;
                    font-size: 15px;
                    font-weight: bold;
                    margin: 12px 0;
                    color: #000;
                    padding: 8px;
                    background-color: #f8f9fa;
                    border-radius: 4px;
                }
                .etims-footer {
                    margin-top: 15px;
                    padding-top: 8px;
                    border-top: 1px solid #ddd;
                    text-align: center;
                    font-size: 11px;
                    color: #666;
                    font-style: italic;
                }
                .account-details {
                    margin: 20px 0;
                    padding: 15px;
                    border: 1px solid #ddd;
                    border-radius: 4px;
                    background-color: #f8f9fa;
                }

                .bank-details, .mpesa-details {
                    margin: 10px 0;
                }

                .bank-details h3, .mpesa-details h3 {
                    font-size: 14px;
                    font-weight: bold;
                    margin-bottom: 5px;
                    color: #333;
                }

                .bank-details p, .mpesa-details p {
                    font-size: 13px;
                    margin: 3px 0;
                    color: #444;
                }

                .control-note {
                    margin-top: 15px;
                    text-align: center;
                    font-weight: bold;
                    font-size: 12px;
                }

                .control-note p {
                    margin: 0;
                }
            </style>
            <div class="invoice-container">
                <h1 class="shop-name">${data.shopName}</h1>
                <p class="shop-details">${data.shopDetails.replace(/\n/g, '<br>')}</p>
                <h2 class="invoice-title">${data.invoiceTitle}</h2>
                
                <p class="invoice-info">
                    <span>Date: ${data.date}</span> | 
                    <span>Invoice No: ${data.invoiceNumber}</span> | 
                    <span>Bill No: ${data.trdInvcNo}</span> |
                    <span>Time: ${data.time}</span>
                </p>
                <p class="print-date">Printed: ${data.printDate}</p>
                <div class="customer-info">
                    <p>Customer: ${data.customer || ''}</p>
                    <p>Pin: ${data.customerTin || ''}</p>
                </div>
                <div class="items-section">
                    <p>Items Sold: ${data.items.length}</p>
                    <table class="items-table">
                        <thead>
                            <tr>
                                <th>Item</th>
                                <th>Qty</th>
                                <th>Price</th>
                                <th>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${data.items.map(item => {
                                const price = Number(item.price) || 0;
                                const amount = Number(item.amount) || 0;
                                return `
                                    <tr>
                                        <td>${item.name}</td>
                                        <td>${item.qty}</td>
                                        <td>${price.toFixed(2)}</td>
                                        <td>${amount.toFixed(2)}</td>
                                    </tr>
                                `;
                            }).join('')}
                        </tbody>
                    </table>
                </div>
                <div class="totals-section">
                    <div style="display: flex; flex-direction: column; align-items: flex-end;">
                        <p style="text-align: right; margin: 5px 0;">
                            <span style="display: inline-block; width: 100px; text-align: left;">Subtotal:</span>
                            <span style="display: inline-block; width: 150px; text-align: right;">KES ${taxableAmount.toFixed(2)}</span>
                        </p>
                        <p style="text-align: right; margin: 5px 0;">
                            <span style="display: inline-block; width: 100px; text-align: left;">VAT:</span>
                            <span style="display: inline-block; width: 150px; text-align: right;">KES ${totalTaxAmount.toFixed(2)}</span>
                        </p>
                        <p class="total-amount" style="text-align: right; margin: 5px 0;">
                            <span style="display: inline-block; width: 100px; text-align: left;">Total:</span>
                            <span style="display: inline-block; width: 150px; text-align: right;">KES ${totalAmount.toFixed(2)}</span>
                        </p>
                    </div>
                </div>
                <div class="qr-section">
                    <img src="${qrCodeDataUrl}" alt="QR Code"/> 
                    <div>
                        <p>RECEIPT SIGNATURE: ${data.receiptSign || ''}</p> 
                        <p>INTERNAL DATA: ${data.internalData || ''}</p> 
                        <p>SCU ID: ${data.businessSCU}</p> 
                        <p>SCU INVOICE NO: ${data.businessSCU}/${data.invoiceNumber}</p> 
                    </div>
                </div>

                <div class="account-details">
                     <p style="margin-bottom: 10px;">
                        <span style="font-weight: bold; font-size: 14px;">Payment Details:</span>
                        <span style="font-size: 11px; color: #666; font-style: italic;"> (For Rentals Only)</span>
                    </p>
                    <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 20px;">
                        <div style="border: 1px solid #ddd; padding: 10px; background: white;">
                            <h3 style="font-size: 14px; font-weight: bold; margin-bottom: 10px;">Bank Details:</h3>
                            <p style="font-size: 13px; margin: 5px 0;">ACCOUNT NAME: Square Metre Consultants Ltd</p>
                            <p style="font-size: 13px; margin: 5px 0;">ACCOUNT NO: 1080280820489</p>
                            <p style="font-size: 13px; margin: 5px 0;">BANK: EQUITY BANK LIMITED</p>
                            <p style="font-size: 13px; margin: 5px 0;">BRANCH: MOMBASA ROAD</p>
                            <p style="font-size: 13px; margin: 5px 0;">BRANCH CODE: 108</p>
                        </div>
                        <div style="border: 1px solid #ddd; padding: 10px; background: white;">
                            <h3 style="font-size: 14px; font-weight: bold; margin-bottom: 10px;">MPESA Details:</h3>
                            <p style="font-size: 13px; margin: 5px 0;">PAYBILL NO: 247247</p>
                            <p style="font-size: 13px; margin: 5px 0;">ACCOUNT NO: 1080280820489</p>
                        </div>
                    </div>
                </div>

                <p class="thank-you">Thanks for Shopping with us!</p>
                <p class="etims-footer">eTIMS Invoice generated by Stanbest Group EA LTD</p>
            </div>`;
        },

        generateThermalInvoice() {
            // Check if this.sale and this.sale.items are defined
            if (!this.selectedSale || !Array.isArray(this.selectedSale.items)) {
                console.error("Sale data is not available or items are not defined.");
                return; // Exit the method if sale data is not available
            }

            const items = this.selectedSale.items.map(item => {
                const mappedItem = {
                    id: item.id,
                    name: item.itemNm, 
                    qty: Number(item.qty), 
                    price: Number(item.prc), 
                    amount: Number(item.totAmt) 
                };
                console.log("Mapped Item:", mappedItem); // Log each mapped item
                return mappedItem;
            });
            console.log("Mapped Items:", items);

            const invoiceData = {
                shopName: "Catholic Diocese of Nakuru",
                shopDetails: "Moi Road\nP.O.Box-938, 20100, NAKURU",
                tillNumber: "BUY GOODS TILL: 9909363",
                invoiceTitle: "SALES INVOICE",
                date: this.formatDate(new Date()), // Current date
                invoiceNumber: this.selectedSale.invcNo, // Use the invoice number from the sale
                trdInvcNo: this.selectedSale.trdInvcNo,
                time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
                printDate: this.formatDate(new Date()), // Current date
                customer: this.selectedSale.custNm,
                customerTin: this.selectedSale.custTin,
                rep: "Isaiah Reg BOOKSHOP",

                batch: "B0000560",
                items: items,
                receiptSign: this.selectedSale.rcptSign,
                internalData: this.selectedSale.intrlData,
                taxable: this.selectedSale.totTaxblAmt, // Total taxable amount
                total: this.selectedSale.totAmt, // Total amount
                totalTaxAmount: this.selectedSale.totTaxAmt, // Total tax amount
                totalPaid: this.selectedSale.totAmt, // Total paid
                balance: 0, // Assuming balance is zero
                paymentMethod: "MPESA",
                qrData: this.getEtimsLink() // Use the eTims URL for the QR code
            };
            console.log("INVOICE DATA:", invoiceData)


            const invoiceHTML = this.createInvoiceThermal(invoiceData);
            this.downloadInvoice(invoiceHTML, `Invoice_${invoiceData.invoiceNumber}.html`);
        },

        createInvoiceThermal(data) {
            const taxableAmount = Number(data.taxable) || 0;
            const totalAmount = Number(data.total) || 0;
            const totalTaxAmount = Number(data.totalTaxAmount) || 0;
            const qrCodeDataUrl = this.generateQRCode(data.qrData);

            return `
            <style>
                @page {
                    size: 80mm auto; /* Adjust width for thermal paper */
                    margin: 0;
                }
                body {
                    width: 80mm; /* Set body width to match paper */
                    font-family: 'Arial', sans-serif;
                    font-size: 12px; /* Smaller font size for thermal printers */
                    color: #000;
                }
                .invoice-container {
                    padding: 5mm;
                }
                .shop-name {
                    font-size: 16px;
                    font-weight: bold;
                    text-align: center;
                    margin-bottom: 5px;
                }
                .shop-details, .till-number {
                    font-size: 10px;
                    text-align: center;
                    margin-bottom: 5px;
                }
                .invoice-title {
                    font-size: 14px;
                    font-weight: bold;
                    text-align: center;
                    margin: 5px 0;
                }
                .invoice-info, .customer-info, .items-section, .totals-section, .qr-section {
                    margin-bottom: 5px;
                }
                .items-table {
                    width: 100%;
                    border-collapse: collapse;
                    font-size: 10px;
                }
                .items-table th, .items-table td {
                    padding: 2px;
                    border-bottom: 1px solid #ddd;
                }
                .totals-section {
                    font-size: 10px;
                }
                .qr-section img {
                    max-width: 60px;
                    margin: 0 auto;
                    display: block;
                }
                .thank-you {
                    text-align: center;
                    font-size: 12px;
                    margin-top: 5px;
                }
                .footer {
                    text-align: center;
                    font-size: 10px;
                    margin-top: 10px;
                    border-top: 1px solid #ddd;
                    padding-top: 5px;
                }
            </style>
            <div class="invoice-container">
                <h1 class="shop-name">${data.shopName}</h1>
                <p class="shop-details">${data.shopDetails.replace(/\n/g, '<br>')}</p>
                <p class="till-number">${data.tillNumber}</p>
                <h2 class="invoice-title">${data.invoiceTitle}</h2>
                
                <p class="invoice-info">
                    Date: ${data.date} | Invoice No: ${data.invoiceNumber} | 
                </p>
                <p class="invoice-info">
                    Bill No: ${data.trdInvcNo}
                </p>
                <div class="customer-info">
                    <p>Customer: ${data.customer || ''}</p>
                    <p>Pin: ${data.customerTin || ''}</p>
                </div>
                <div class="items-section">
                    <p>Items Sold: ${data.items.length}</p>
                    <table class="items-table">
                        <thead>
                            <tr>
                                <th>Item</th>
                                <th>Qty</th>
                                <th>Price</th>
                                <th>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${data.items.map(item => `
                                <tr>
                                    <td>${item.name}</td>
                                    <td>${item.qty}</td>
                                    <td>${Number(item.price).toFixed(2)}</td>
                                    <td>${Number(item.amount).toFixed(2)}</td>
                                </tr>
                            `).join('')}
                        </tbody>
                    </table>
                </div>
                <div class="totals-section">
                    <p>Subtotal: KES ${taxableAmount.toFixed(2)}</p>
                    <p>VAT: KES ${totalTaxAmount.toFixed(2)}</p>
                    <p>Total: KES ${totalAmount.toFixed(2)}</p>
                </div>
                <div class="qr-section">
                    <img src="${qrCodeDataUrl}" alt="QR Code"/> 
                    <div>
                        <p>SCU ID: KRACU0300002211</p> 
                        <p>SCU INVOICE NO: KRACU0300002211/${data.invoiceNumber}</p> 
                    </div>
                </div>
                <p class="thank-you">Thanks for Shopping with us!</p>
                <div class="footer">
                    <p>Powered by:</p>
                    <p>Stanbest Group EA LTD</p>
                    <p>Contact: 0715 713493</p>
                </div>
            </div>`;
        },

        generateRavineInvoice() {
            // Validate sale data
            if (!this.selectedSale || !Array.isArray(this.selectedSale.items)) {
                console.error("Sale data is not available or items are not defined.");
                return;
            }

            // Map items
            const items = this.selectedSale.items.map(item => ({
                id: item.id,
                name: item.itemNm,
                qty: Number(item.qty),
                price: Number(item.prc),
                amount: Number(item.totAmt)
            }));

            // Prepare invoice data
            const invoiceData = {
                shopName: "Mercy Mission hospital - Eldama Ravine",
                shopDetails: "10",
                invoiceTitle: "CUSTOMER INVOICE",
                date: this.formatDate(new Date()),
                invoiceNumber: this.selectedSale.invcNo,
                trdInvcNo: this.selectedSale.trdInvcNo,
                time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
                printDate: this.formatDate(new Date()),
                customer: this.selectedSale.custNm,
                customerTin: this.selectedSale.custTin,
                items: items,
                receiptSign: this.selectedSale.rcptSign,
                internalData: this.selectedSale.intrlData,
                taxable: this.selectedSale.totTaxblAmt,
                total: this.selectedSale.totAmt,
                totalTaxAmount: this.selectedSale.totTaxAmt,
                qrData: this.getEtimsLink(),
                preparedBy: '',
                membership: ''
            };

            // Generate invoice HTML
            const invoiceHTML = this.createInvoiceRavine(invoiceData);

            // Download invoice
            this.downloadInvoice(invoiceHTML, `Invoice_${invoiceData.invoiceNumber}.html`);
        },

        createInvoiceRavine(data) {
            const totalAmount = Number(data.total) || 0;
            const qrCodeDataUrl = this.generateQRCode(data.qrData);
            
            return `
            <!DOCTYPE html>
            <html>
            <head>
                <meta charset="utf-8">
                <title>Invoice ${data.invoiceNumber}</title>
                <style>
                    /* Reset CSS */
                    * {
                        margin: 0;
                        padding: 0;
                        box-sizing: border-box;
                    }

                    /* Print-specific styles */
                    @media print {
                        body {
                            -webkit-print-color-adjust: exact !important;
                            print-color-adjust: exact !important;
                        }
                        
                        @page {
                            size: A4;
                            margin: 15mm;
                        }
                    }

                    body {
                        font-family: Arial, sans-serif;
                        line-height: 1.3;
                        color: #000;
                        background: #fff;
                    }

                    .invoice-container {
                        width: 210mm;
                        min-height: 297mm;
                        padding: 20mm;
                        margin: 0 auto;
                        background: white;
                    }

                    .invoice-header {
                        background-color: #87CEEB !important;
                        color: black;
                        text-align: center;
                        padding: 10px;
                        margin-bottom: 20px;
                        font-weight: bold;
                        font-size: 18px;
                        border-radius: 4px;
                    }

                    .info-section {
                        display: flex;
                        justify-content: space-between;
                        gap: 20px;
                        margin-bottom: 20px;
                    }

                    .info-box {
                        flex: 1;
                        border: 1px solid black;
                        padding: 15px;
                        border-radius: 4px;
                    }

                    .info-box p {
                        margin: 5px 0;
                        font-size: 12px;
                        line-height: 1.4;
                    }

                    .details-section {
                        border: 1px solid black;
                        padding: 15px;
                        margin-bottom: 20px;
                        border-radius: 4px;
                    }

                    .details-grid {
                        display: grid;
                        grid-template-columns: repeat(2, 1fr);
                        gap: 10px;
                    }

                    .details-grid p {
                        margin: 5px 0;
                        font-size: 12px;
                    }

                    .items-table {
                        width: 100%;
                        border-collapse: collapse;
                        margin: 20px 0;
                        page-break-inside: auto;
                    }

                    .items-table tr {
                        page-break-inside: avoid;
                        page-break-after: auto;
                    }

                    .items-table th, 
                    .items-table td {
                        border: 1px solid black;
                        padding: 8px;
                        text-align: left;
                        font-size: 12px;
                    }

                    .items-table th {
                        background-color: #ffffff;
                        font-weight: bold;
                    }

                    .totals-section {
                        text-align: right;
                        margin-top: 20px;
                        page-break-inside: avoid;
                    }

                    .totals-section p {
                        margin: 5px 0;
                        font-size: 12px;
                    }

                    .signature-section {
                        display: flex;
                        justify-content: space-between;
                        margin-top: 40px;
                        page-break-inside: avoid;
                    }

                    .signature-box {
                        width: 45%;
                    }

                    .signature-box p {
                        font-size: 12px;
                        margin-bottom: 5px;
                    }

                    .signature-line {
                        border-top: 1px solid black;
                        width: 80%;
                        margin-top: 40px;
                    }

                    /* Ensure proper page breaks */
                    .page-break {
                        page-break-after: always;
                    }

                    /* Prevent unwanted breaks */
                    .no-break {
                        page-break-inside: avoid;
                    }
                    
                    .qr-section {
                        display: flex;
                        align-items: flex-start;
                        justify-content: flex-start;
                        margin: 20px 0;
                        padding: 15px;
                        border: 1px solid black;
                        border-radius: 4px;
                        page-break-inside: avoid;
                    }

                    .qr-code-container {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        margin-right: 20px;
                    }

                    .qr-section img {
                        width: 100px;
                        height: 100px;
                        border: 1px solid #ddd;
                        padding: 5px;
                    }

                    .qr-details {
                        flex: 1;
                    }

                    .qr-details p {
                        margin: 5px 0;
                        font-size: 12px;
                        line-height: 1.4;
                    }

                    .qr-details strong {
                        font-weight: bold;
                    }
                
                    .etims-footer {
                            margin-top: 15px;
                            padding-top: 8px;
                            border-top: 1px solid #ddd;
                            text-align: center;
                            font-size: 11px;
                            color: #666;
                            font-style: italic;
                        }
                
                </style>
            </head>
            <body>
                <div class="invoice-container">
                    <div class="invoice-header">
                        Customer Invoice
                    </div>
                    
                    <div class="info-section">
                        <div class="info-box">
                            <p><strong>Mercy Mission Hospital - Eldama Ravine</strong></p>
                            <p>Address: 10</p>
                            <p>Telephone: 0770321365</p>
                            <p>Email: mercymissionhospital@gmail.com</p>
                        </div>
                        <div class="info-box">
                            <p><strong>Client Name:</strong> ${data.customer || ''}</p>
                            <p><strong>Client Pin:</strong> ${data.customerTin || ''}</p>
                        </div>
                    </div>

                    <div class="details-section">
                        <div class="details-grid">
                            <p><strong>Invoice No:</strong> ${data.invoiceNumber}</p>
                            <p><strong>Bill No:</strong> ${data.trdInvcNo}</p>
                            <p><strong>Created On:</strong> ${data.date}</p>
                            <p><strong>Due Date:</strong> ${data.printDate}</p>
                        </div>
                    </div>

                    <table class="items-table">
                        <thead>
                            <tr>
                                <th>No</th>
                                <th>Item</th>
                                <th>Quantity</th>
                                <th>Rate</th>
                                <th>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${data.items.map((item, index) => `
                                <tr>
                                    <td>${index + 1}</td>
                                    <td>${item.name}</td>
                                    <td>${item.qty}</td>
                                    <td>${(item.price || 0).toFixed(2)}</td>
                                    <td>${(item.amount || 0).toFixed(2)}</td>
                                </tr>
                            `).join('')}
                        </tbody>
                    </table>

                    <div class="totals-section">
                        <p><strong>Total:</strong> ${totalAmount.toFixed(2)}</p>
                        <p><strong>Co-Payment:</strong> 0.00</p>
                        <p><strong>Customer Amount:</strong> 0.00</p>
                        <p><strong>Discount:</strong> 0.00</p>
                        <p><strong>Credit Note:</strong> 0.00</p>
                        <p><strong>Write-Off:</strong> 0.00</p>
                        <p><strong>Balance:</strong> ${totalAmount.toFixed(2)}</p>
                    </div>

                    <div class="qr-section">
                    <div class="qr-code-container">
                        <img src="${qrCodeDataUrl}" alt="QR Code"/>
                    </div>
                    <div class="qr-details">
                        <p><strong>Receipt Signature:</strong> ${data.receiptSign || 'N/A'}</p>
                        <p><strong>Internal Data:</strong> ${data.internalData || 'N/A'}</p>
                        <p><strong>SCU ID:</strong> KRACU0300002371</p>
                        <p><strong>SCU Invoice No:</strong> KRACU0300002371/${data.invoiceNumber}</p>
                    </div>
                </div>

                    <div class="signature-section">
                        <div class="signature-box">
                            <p>Prepared by: ${data.preparedBy || ''}</p>
                            <div class="signature-line"></div>
                        </div>
                        <div class="signature-box">
                            <p>Customer</p>
                            <div class="signature-line"></div>
                        </div>
                    </div>
                    <p class="etims-footer">eTIMS Invoice generated by Stanbest Group EA LTD</p>
                </div>
            </body>
            
            </html>`;
        },


        generateMMNInvoice() {
            // Validate sale data
            if (!this.selectedSale || !Array.isArray(this.selectedSale.items)) {
                console.error("Sale data is not available or items are not defined.");
                return;
            }

            // Map items
            const items = this.selectedSale.items.map(item => ({
                id: item.id,
                name: item.itemNm,
                qty: Number(item.qty),
                price: Number(item.prc),
                amount: Number(item.totAmt)
            }));

            // Prepare invoice data
            const invoiceData = {
                shopName: "Our Lady of Mercy Mission Hospital",
                shopDetails: "P.O Box 938-20100",
                phone: "0736 950 739",
                email: "mercymissionhospital@gmail.com",
                invoiceTitle: "Customer Invoice",
                date: this.formatDate(new Date()),
                invoiceNumber: this.selectedSale.invcNo,
                billNo: this.selectedSale.trdInvcNo,
                time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
                printDate: this.formatDate(new Date()),
                customer: this.selectedSale.custNm,
                customerTin: this.selectedSale.custTin,
                items: items,
                receiptSign: this.selectedSale.rcptSign,
                internalData: this.selectedSale.intrlData,
                taxable: this.selectedSale.totTaxblAmt,
                total: this.selectedSale.totAmt,
                totalTaxAmount: this.selectedSale.totTaxAmt,
                qrData: this.getEtimsLink()
            };

            // Generate and download invoice
            const invoiceHTML = this.createMMNInvoice(invoiceData);
            this.downloadInvoice(invoiceHTML, `Invoice_${invoiceData.invoiceNumber}.html`);
        },



        createMMNInvoice(data) {
        const totalAmount = Number(data.total) || 0;
        const qrCodeDataUrl = this.generateQRCode(data.qrData);
        
        return `
        <!DOCTYPE html>
        <html>
        <head>
            <meta charset="utf-8">
            <title>Invoice ${data.invoiceNumber}</title>
            <style>
                /* Reset CSS */
                * {
                    margin: 0;
                    padding: 0;
                    box-sizing: border-box;
                }

                /* Print-specific styles */
                @media print {
                    body {
                        -webkit-print-color-adjust: exact !important;
                        print-color-adjust: exact !important;
                    }
                    
                    @page {
                        size: A4;
                        margin: 15mm;
                    }
                }

                body {
                    font-family: Arial, sans-serif;
                    line-height: 1.3;
                    color: #000;
                    background: #fff;
                }

                .invoice-container {
                    width: 210mm;
                    min-height: 297mm;
                    padding: 20mm;
                    margin: 0 auto;
                    background: white;
                }

                .invoice-header {
                    background-color: #87CEEB !important;
                    color: black;
                    text-align: center;
                    padding: 10px;
                    margin-bottom: 20px;
                    font-weight: bold;
                    font-size: 18px;
                    border-radius: 4px;
                }

                .info-section {
                    display: flex;
                    justify-content: space-between;
                    gap: 20px;
                    margin-bottom: 20px;
                }

                .info-box {
                    flex: 1;
                    border: 1px solid black;
                    padding: 15px;
                    border-radius: 4px;
                }

                .info-box p {
                    margin: 5px 0;
                    font-size: 12px;
                    line-height: 1.4;
                }

                .details-section {
                    border: 1px solid black;
                    padding: 15px;
                    margin-bottom: 20px;
                    border-radius: 4px;
                }

                .details-grid {
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                    gap: 10px;
                }

                .details-grid p {
                    margin: 5px 0;
                    font-size: 12px;
                }

                .items-table {
                    width: 100%;
                    border-collapse: collapse;
                    margin: 20px 0;
                    page-break-inside: auto;
                }

                .items-table tr {
                    page-break-inside: avoid;
                    page-break-after: auto;
                }

                .items-table th, 
                .items-table td {
                    border: 1px solid black;
                    padding: 8px;
                    text-align: left;
                    font-size: 12px;
                }

                .items-table th {
                    background-color: #ffffff;
                    font-weight: bold;
                }

                .totals-section {
                    text-align: right;
                    margin-top: 20px;
                    page-break-inside: avoid;
                }

                .totals-section p {
                    margin: 5px 0;
                    font-size: 12px;
                }

                .signature-section {
                    display: flex;
                    justify-content: space-between;
                    margin-top: 40px;
                    page-break-inside: avoid;
                }

                .signature-box {
                    width: 45%;
                }

                .signature-box p {
                    font-size: 12px;
                    margin-bottom: 5px;
                }

                .signature-line {
                    border-top: 1px solid black;
                    width: 80%;
                    margin-top: 40px;
                }

                /* Ensure proper page breaks */
                .page-break {
                    page-break-after: always;
                }

                /* Prevent unwanted breaks */
                .no-break {
                    page-break-inside: avoid;
                }
                
                .qr-section {
                    display: flex;
                    align-items: flex-start;
                    justify-content: flex-start;
                    margin: 20px 0;
                    padding: 15px;
                    border: 1px solid black;
                    border-radius: 4px;
                    page-break-inside: avoid;
                }

                .qr-code-container {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    margin-right: 20px;
                }

                .qr-section img {
                    width: 100px;
                    height: 100px;
                    border: 1px solid #ddd;
                    padding: 5px;
                }

                .qr-details {
                    flex: 1;
                }

                .qr-details p {
                    margin: 5px 0;
                    font-size: 12px;
                    line-height: 1.4;
                }

                .qr-details strong {
                    font-weight: bold;
                }
            
                .etims-footer {
                        margin-top: 15px;
                        padding-top: 8px;
                        border-top: 1px solid #ddd;
                        text-align: center;
                        font-size: 11px;
                        color: #666;
                        font-style: italic;
                    }
            
            </style>
        </head>
        <body>
            <div class="invoice-container">
                <div class="invoice-header">
                    Customer Invoice
                </div>
                
                <div class="info-section">  
                    <div class="info-box">
                        <p><strong>Our Lady of Mercy Mission Hospital</strong></p>
                        <p>Address:  P.O Box 938-20100</p>
                        <p>Telephone: 0796 560 759</p>
                        <p>Email: mercymissionhospital@gmail.com</p>
                    </div>
                    <div class="info-box">
                        <p><strong>Client Name:</strong> ${data.customer || ''}</p>
                        <p><strong>Client Pin:</strong> ${data.customerTin || ''}</p>
                    </div>
                </div>

                <div class="details-section">
                    <div class="details-grid">
                        <p><strong>Invoice No:</strong> ${data.invoiceNumber}</p>
                        <p><strong>Bill No:</strong> ${data.billNo}</p>
                        <p><strong>Created On:</strong> ${data.date}</p>
                        <p><strong>Due Date:</strong> ${data.printDate}</p>
                    </div>
                </div>

                <table class="items-table">
                    <thead>
                        <tr>
                            <th>No</th>
                            <th>Item</th>
                            <th>Quantity</th>
                            <th>Rate</th>
                            <th>Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${data.items.map((item, index) => `
                            <tr>
                                <td>${index + 1}</td>
                                <td>${item.name}</td>
                                <td>${item.qty}</td>
                                <td>${(item.price || 0).toFixed(2)}</td>
                                <td>${(item.amount || 0).toFixed(2)}</td>
                            </tr>
                        `).join('')}
                    </tbody>
                </table>

                <div class="totals-section">
                    <p><strong>Total:</strong> ${totalAmount.toFixed(2)}</p>
                    <p><strong>Co-Payment:</strong> 0.00</p>
                    <p><strong>Customer Amount:</strong> 0.00</p>
                    <p><strong>Discount:</strong> 0.00</p>
                    <p><strong>Credit Note:</strong> 0.00</p>
                    <p><strong>Write-Off:</strong> 0.00</p>
                    <p><strong>Balance:</strong> ${totalAmount.toFixed(2)}</p>
                </div>

                <div class="qr-section">
                <div class="qr-code-container">
                    <img src="${qrCodeDataUrl}" alt="QR Code"/>
                </div>
                <div class="qr-details">
                    <p><strong>Receipt Signature:</strong> ${data.receiptSign || 'N/A'}</p>
                    <p><strong>Internal Data:</strong> ${data.internalData || 'N/A'}</p>
                    <p><strong>SCU ID:</strong> KRACU0300002368</p>
                    <p><strong>SCU Invoice No:</strong> KRACU0300002368/${data.invoiceNumber}</p>
                </div>
            </div>

                <div class="signature-section">
                    <div class="signature-box">
                        <p>Prepared by: ${data.preparedBy || ''}</p>
                        <div class="signature-line"></div>
                    </div>
                    <div class="signature-box">
                        <p>Customer</p>
                        <div class="signature-line"></div>
                    </div>
                </div>
                <p class="etims-footer">eTIMS Invoice generated by Stanbest Group EA LTD</p>
            </div>
        </body>
        
        </html>`;
    },

    generateDigiInvoice() {
            // Validate sale data
            if (!this.selectedSale || !Array.isArray(this.selectedSale.items)) {
                console.error("Sale data is not available or items are not defined.");
                return;
            }

            // Map items
            const items = this.selectedSale.items.map(item => ({
                id: item.id,
                name: item.itemNm,
                qty: Number(item.qty),
                price: Number(item.prc),
                amount: Number(item.totAmt)
            }));

            // Prepare invoice data
            const invoiceData = {
                shopName: "DIGITALENT SYSTEMS",
                shopDetails: "P.O. Box 43684-00100, NAIROBI, KENYA",
                invoiceTitle: "INVOICE",
                date: this.formatDate(new Date()),
                invoiceNumber: this.selectedSale.invcNo,
                trdInvcNo: this.selectedSale.trdInvcNo,
                customer: this.selectedSale.custNm,
                customerTin: this.selectedSale.custTin,
                items: items,
                total: this.selectedSale.totAmt,
                totalTaxAmount: this.selectedSale.totTaxAmt,
                // totalTaxAmount: Math.abs(this.selectedSale.totTaxAmt),
                receiptSign: this.selectedSale.rcptSign,
                internalData: this.selectedSale.intrlData,
                qrData: this.getEtimsLink(),
            };

            // Generate and download invoice
            const invoiceHTML = this.createDigiInvoice(invoiceData);
            this.downloadInvoice(invoiceHTML, `Invoice_${invoiceData.invoiceNumber}.html`);
        },


        createDigiInvoice(data) {
        const totalAmount = Number(data.total) || 0;
        const totalTaxAmount = Number(data.totalTaxAmount) || 0;
        const qrCodeDataUrl = this.generateQRCode(data.qrData);

        return `
        <!DOCTYPE html>
        <html>
        <head>
            <meta charset="utf-8">
            <title>Invoice ${data.invoiceNumber}</title>
            <style>
                * {
                    margin: 0;
                    padding: 0;
                    box-sizing: border-box;
                }
                body {
                    font-family: Arial, sans-serif;
                    font-size: 11px;
                    line-height: 1.5;
                    color: #000;
                }
                .invoice-container {
                    width: 100%;
                    max-width: 800px;
                    margin: 0 auto;
                    padding: 20px;
                }
                .header {
                    text-align: center; /* Center the header content */
                    margin-bottom: 20px;
                }
                .logo {
                    max-width: 150px; /* Reduced size of the logo */
                    margin-bottom: 2px; /* Space below the logo */
                }
                .shop-details {
                    font-size: 10px; /* Reduced font size for shop details */
                    margin-bottom: 5px; /* Space below shop details */
                }
                .invoice-details {
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 15px;
                    border-bottom: 1px solid #000;
                    padding-bottom: 10px;
                }
                .company-details, .invoice-meta, .invoice-header {
                    flex: 1;
                    text-align: center; /* Center text in each column */
                }
                .invoice-header h1 {
                    font-size: 18px;
                    font-weight: bold;
                    margin-bottom: 5px;
                }
                .items-table {
                    width: 100%;
                    border-collapse: collapse;
                    margin-bottom: 15px;
                }
                .items-table th, 
                .items-table td {
                    border: 1px solid #000;
                    padding: 5px;
                    text-align: left;
                }
                .items-table th {
                    background-color: #f0f0f0;
                }
                .totals-section {
                    text-align: right;
                    margin-bottom: 15px;
                }
                .bank-details-container {
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 15px;
                }
                .bank-details {
                    flex: 1;
                    margin-right: 20px;
                }
                .qr-section {
                    display: flex;
                    align-items: flex-start;
                    margin-bottom: 15px;
                }
                .qr-code-container {
                    margin-right: 20px;
                }
                .qr-code-container img {
                    width: 100px;
                    height: 100px;
                }
                .payment-advice {
                    border-top: 1px solid #000;
                    padding-top: 10px;
                    margin-top: 15px;
                }
                .payment-advice-details {
                    display: flex;
                    justify-content: space-between;
                }
                .payment-advice-details div {
                    flex: 1;
                }
                 .etims-footer {
                    margin-top: 15px;
                    padding-top: 8px;
                    border-top: 1px solid #ddd;
                    text-align: center;
                    font-size: 11px;
                    color: #666;
                    font-style: italic;
                }
            </style>
        </head>
        <body>
            <div class="invoice-container">
                <div class="header">
                    <div class="shop-details">
                        <h2>${data.shopName}</h2>
                        <p>${data.shopDetails}</p>
                        <br>
                        <h1>INVOICE</h1>
                    </div>
                </div>
                <div class="invoice-details">
                    <div class="invoice-header">
                        <p><strong>Client Name:</strong> ${data.customer || '' }</p>
                        <p><strong>Client Pin:</strong> ${data.customerTin || ''}</p>
                    </div>
                    <div class="invoice-meta">
                        <p><strong>Invoice Date:</strong> ${data.date}</p>
                        <p><strong>Invoice Number:</strong> ${data.invoiceNumber}</p>
                        <p><strong>Bill No:</strong> ${data.trdInvcNo}</p>
                    </div>
                    <div class="company-details">
                        <p><strong>DIGITALENT SYSTEMS</strong></p>
                        <p>P051440408O</p>
                    </div>
                </div>

                <table class="items-table">
                    <thead>
                        <tr>
                            <th>Description</th>
                            <th>Quantity</th>
                            <th>Unit Price</th>
                            <th>Tax </th>
                            <th>Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${data.items.map(item => `
                            <tr>
                                <td>${item.name}</td>
                                <td>${item.qty}</td>
                                <td>${(item.price || 0).toFixed(2)}</td>
                                <td>${((item.qty * item.price * 0.16) || 0).toFixed(2)}</td>
                                <td>${(item.amount || 0).toFixed(2)}</td>
                            </tr>
                        `).join('')}
                    </tbody>
                </table>

                <div class="totals-section">
                    <p>Subtotal KES: ${(totalAmount - totalTaxAmount ).toFixed(2)}</p>
                    <p>Total Tax (16%) KES:  ${totalTaxAmount.toFixed(2)}</p>
                    <p><strong>Total Amount KES: ${(totalAmount).toFixed(2)}</strong></p>
                </div>

                <div class="bank-details-container">
                    <div class="qr-section">
                        <div class="qr-code-container">
                            <img src="${qrCodeDataUrl}" alt="QR Code"/>
                        </div>
                        <div class="qr-details">
                            <p><strong>Receipt Signature:</strong> ${data.receiptSign || 'N/A'}</p>
                            <p><strong>Internal Data:</strong> ${data.internalData || 'N/A'}</p>
                            <p><strong>SCU ID:</strong>  KRACU0300002142</p>
                            <p><strong>SCU Invoice No:</strong>  KRACU0300002142/${data.invoiceNumber}</p>
                        </div>
                    </div>
                </div>

                <div class="payment-advice">
                    <h3>PAYMENT ADVICE</h3>
                    <div class="payment-advice-details">
                        <div>
                            <p>To:</p>
                            <p>DIGITALENT SYSTEMS LIMITED</p>
                            <p>ATTENTION: BORIS AGONGA</p>
                            <p>P. O. Box 43684-00100</p>
                            <p>NAIROBI, KENYA</p>
                        </div>
                        <div>
                            <p><strong>Customer:</strong> ${data.customer || ''}</p>
                            <p><strong>Invoice Number:</strong> ${data.invoiceNumber}</p>
                            <p><strong>Amount Due:</strong> KES ${(totalAmount + totalTaxAmount).toFixed(2)}</p>
                        </div>
                        <div>
                            <p>Amount Enclosed:</p>
                            <p>Enter the amount you are paying above</p>
                            <p>&nbsp;</p>
                            <p>Company Pin: ${data.registrationNo || 'PO51440408O'}</p>
                        </div>
                    </div>
                </div>
                <p class="etims-footer">eTIMS Invoice generated by Stanbest Group EA LTD</p>
            </div>
        </body>
        </html>`;
    },

    generateSankuInvoice() {
        if (!this.selectedSale || !Array.isArray(this.selectedSale.items)) {
            console.error("Sale data is not available or items are not defined.");
            return;
        }

        const businessName = JSON.parse(localStorage.getItem('businessName')) || 'Sanku Project Healthy Children';
        const businessPin = JSON.parse(localStorage.getItem('businessPin')) || '';
        const businessEmail = JSON.parse(localStorage.getItem('businessEmail')) || '';
        const businessPhone = JSON.parse(localStorage.getItem('businessPhone')) || '';
        const businessSCU = JSON.parse(localStorage.getItem('businessSCU')) || '';

        const items = this.selectedSale.items.map(item => ({
            id: item.id,
            name: item.itemNm,
            code: item.itemCd || '',
            qty: Number(item.qty),
            price: Number(item.prc),
            amount: Number(item.totAmt)
        }));

        const rawDateStr = String(this.selectedSale.salesDt); 

        const formattedDate = `${rawDateStr.slice(0, 4)}-${rawDateStr.slice(4, 6)}-${rawDateStr.slice(6, 8)}`;

        const invoiceData = {
            businessName,
            businessPin,
            businessEmail,
            businessPhone,
            businessSCU,
            invoiceNumber: this.selectedSale.invcNo,
            billNo: this.selectedSale.trdInvcNo,
            date: formattedDate,
            customerName: this.selectedSale.custNm || '',
            customerPin: this.selectedSale.custTin || '',
            receiptSign: this.selectedSale.rcptSign || '',
            internalData: this.selectedSale.intrlData || '',
            items,
            subtotal: Number(this.selectedSale.totTaxblAmt || 0),
            taxAmount: Number(this.selectedSale.totTaxAmt || 0),
            total: Number(this.selectedSale.totAmt || 0),
            qrData: this.getEtimsLink()
        };

        const invoiceHTML = this.createSankuInvoice(invoiceData);
        this.downloadInvoice(invoiceHTML, `Invoice_${invoiceData.invoiceNumber}.html`);
    },

    createSankuInvoice(data) {
        const qrCodeDataUrl = this.generateQRCode(data.qrData);
        const formatMoney = (value) => Number(value || 0).toLocaleString('en-KE', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });

        return `
        <!DOCTYPE html>
        <html>
        <head>
            <meta charset="utf-8">
            <title>Invoice ${data.invoiceNumber}</title>
            <style>
                * {
                    margin: 0;
                    padding: 0;
                    box-sizing: border-box;
                }

                @media print {
                    body {
                        -webkit-print-color-adjust: exact !important;
                        print-color-adjust: exact !important;
                    }

                    @page {
                        size: A4;
                        margin: 12mm;
                    }
                }

                body {
                    font-family: Arial, sans-serif;
                    color: #222;
                    background: #fff;
                    line-height: 1.35;
                }

                .invoice-container {
                    width: 210mm;
                    min-height: 297mm;
                    padding: 16mm 14mm;
                    margin: 0 auto;
                    background: white;
                }

                .header {
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-start;
                    margin-bottom: 26px;
                }

                .brand {
                    max-width: 60%;
                }

                .logo-wordmark {
                    display: flex;
                    align-items: baseline;
                    gap: 2px;
                    font-size: 42px;
                    font-weight: 700;
                    line-height: 1;
                    letter-spacing: -1px;
                    text-transform: lowercase;
                }

                .logo-s {
                    color: #f39a22;
                }

                .logo-rest {
                    color: #5c5c5c;
                }

                .brand-subtitle {
                    font-size: 15px;
                    font-weight: 700;
                    color: #2b2b2b;
                    margin-top: 2px;
                    text-transform: uppercase;
                }

                .invoice-meta {
                    text-align: right;
                    font-size: 13px;
                    font-weight: 600;
                    color: #444;
                    padding-top: 14px;
                }

                .invoice-title {
                    text-align: center;
                    font-size: 22px;
                    font-weight: 700;
                    margin: 10px 0 18px;
                    color: #2f2f2f;
                }

                .top-section {
                    display: flex;
                    justify-content: space-between;
                    gap: 24px;
                    margin-bottom: 20px;
                }

                .address-block,
                .client-block {
                    flex: 1;
                    font-size: 12px;
                    color: #3e3e3e;
                }

                .address-block p,
                .client-block p {
                    margin-bottom: 3px;
                }

                .client-block {
                    text-align: right;
                }

                .items-table {
                    width: 100%;
                    border-collapse: collapse;
                    margin-top: 12px;
                }

                .items-table thead th {
                    background: #ececec;
                    color: #2a2a2a;
                    text-align: left;
                    font-size: 12px;
                    padding: 10px 8px;
                    border-top: 1px solid #cfcfcf;
                    border-bottom: 1px solid #cfcfcf;
                }

                .items-table tbody td {
                    font-size: 12px;
                    padding: 9px 8px;
                    border-bottom: 1px solid #dcdcdc;
                    vertical-align: top;
                }

                .items-table th:nth-child(3),
                .items-table th:nth-child(4),
                .items-table th:nth-child(5),
                .items-table td:nth-child(3),
                .items-table td:nth-child(4),
                .items-table td:nth-child(5) {
                    text-align: right;
                }

                .totals {
                    width: 280px;
                    margin-left: auto;
                    margin-top: 16px;
                    font-size: 12px;
                }

                .totals-row {
                    display: flex;
                    justify-content: space-between;
                    padding: 5px 0;
                    border-bottom: 1px solid #dcdcdc;
                }

                .totals-row.total {
                    margin-top: 6px;
                    padding: 9px 10px;
                    font-size: 16px;
                    font-weight: 700;
                    background: #efefef;
                    border-bottom: none;
                }

                .notes {
                    margin-top: 26px;
                    font-size: 11px;
                    color: #404040;
                }

                .notes p {
                    margin-bottom: 4px;
                }

                .bank-details {
                    margin-top: 18px;
                    font-size: 11px;
                    color: #3a3a3a;
                }

                .bank-details p {
                    margin-bottom: 3px;
                }

                .signature-row {
                    display: grid;
                    grid-template-columns: repeat(3, 1fr);
                    gap: 24px;
                    margin-top: 38px;
                    font-size: 11px;
                    color: #444;
                }

                .signature-line {
                    height: 28px;
                    border-bottom: 1px solid #7e7e7e;
                    margin-bottom: 6px;
                }

                .compliance {
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-end;
                    margin-top: 34px;
                    gap: 16px;
                }

                .qr-block {
                    display: flex;
                    align-items: flex-start;
                    gap: 10px;
                    font-size: 10px;
                    color: #525252;
                }

                .qr-block img {
                    width: 88px;
                    height: 88px;
                    border: 1px solid #d6d6d6;
                    padding: 4px;
                    background: #fff;
                }

                .footer {
                    margin-top: 48px;
                    text-align: center;
                    font-size: 10px;
                    color: #555;
                }
            </style>
        </head>
        <body>
            <div class="invoice-container">
                <div class="header">
                    <div class="brand">
                        <div class="logo-wordmark">
                            <span class="logo-s">s</span><span class="logo-rest">anku</span>
                        </div>
                        <div class="brand-subtitle">Project Healthy Children</div>
                    </div>
                    <div class="invoice-meta">
                        <p>INVOICE NO. ${data.invoiceNumber}</p>
                        <p>Date: ${data.date}</p>
                    </div>
                </div>

                <div class="top-section">
                    <div class="address-block">
                        <p>${data.businessName}</p>
                        ${data.businessPhone ? `<p>${data.businessPhone}</p>` : ''}
                        ${data.businessEmail ? `<p>${data.businessEmail}</p>` : ''}
                        ${data.businessPin ? `<p>PIN: ${data.businessPin}</p>` : ''}
                        ${data.billNo ? `<p>Bill No: ${data.billNo}</p>` : ''}
                    </div>
                    <div class="client-block">
                        <p><strong>${data.customerName}</strong></p>
                        ${data.customerPin ? `<p>PIN: ${data.customerPin}</p>` : ''}
                    </div>
                </div>

                <div class="invoice-title">INVOICE</div>

                <table class="items-table">
                    <thead>
                        <tr>
                            <th>Item</th>
                            <th>Description</th>
                            <th>Unit Price KES</th>
                            <th>Quantity</th>
                            <th>Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${data.items.map(item => `
                            <tr>
                                <td>${item.code || item.name}</td>
                                <td>${item.name}</td>
                                <td>${formatMoney(item.price)}</td>
                                <td>${item.qty}</td>
                                <td>${formatMoney(item.amount)}</td>
                            </tr>
                        `).join('')}
                    </tbody>
                </table>

                <div class="totals">
                    <div class="totals-row">
                        <span>Subtotal</span>
                        <span>KES ${formatMoney(data.subtotal)}</span>
                    </div>
                    <div class="totals-row">
                        <span>Tax Total (16%)</span>
                        <span>KES ${formatMoney(data.taxAmount)}</span>
                    </div>
                    <div class="totals-row total">
                        <span>Total</span>
                        <span>KES ${formatMoney(data.total)}</span>
                    </div>
                </div>

                <div class="notes">
                    <p>Delivery Terms: Prompt will be collected by the customer from the Sanku warehouse.</p>
                    <p>Payment otherwise agreed as per purchase order instructions.</p>
                    <p>Please forward cash only before dispatch.</p>
                    <p>Please pay using these banking details:</p>
                </div>

                <div class="bank-details">
                    <p>Kenya Shilling Account</p>
                    <p>Bank: Absa Bank Kenya PLC</p>
                    <p>Currency: Kenya Shilling</p>
                    <p>A/c Name: Sanku Fortification Kenya Limited</p>
                    <p>A/c No: 2650858046</p>
                    <p>Swift Code: BARCKENX</p>
                    <p>Bank code: 03</p>
                </div>

                <div class="signature-row">
                    <div>
                        <div class="signature-line"></div>
                        <p>Supply Chain Signed:</p>
                    </div>
                    <div>
                        <div class="signature-line"></div>
                        <p>Finance Signed:</p>
                    </div>
                    <div>
                        <div class="signature-line"></div>
                        <p>Date:</p>
                    </div>
                </div>

                <div class="compliance">
                    <div></div>
                    <div class="qr-block">
                        <img src="${qrCodeDataUrl}" alt="QR Code" />
                        <div>
                            ${data.businessSCU ? `<p><strong>SCU ID:</strong> ${data.businessSCU}</p>` : ''}
                            ${data.businessSCU ? `<p><strong>SCU Invoice No:</strong> ${data.businessSCU}/${data.invoiceNumber}</p>` : ''}
                            ${data.receiptSign ? `<p><strong>Receipt Signature:</strong> ${data.receiptSign}</p>` : ''}
                            ${data.internalData ? `<p><strong>Internal Data:</strong> ${data.internalData}</p>` : ''}
                        </div>
                    </div>
                </div>

                <div class="footer">
                    Nairobi Gate Industrial Park, Eastern Bypass, Unit 5, Nairobi, Kenya
                </div>
            </div>
        </body>
        </html>`;
    },

    //////////////////////////////////////GENERAL INVOICE/////////////////////////////////////

    generateGeneralInvoice() {
            // Validate sale data
            if (!this.selectedSale || !Array.isArray(this.selectedSale.items)) {
                console.error("Sale data is not available or items are not defined.");
                return;
            }

            let businessName = JSON.parse(localStorage.getItem('businessName')) || ''
            let businessPin = JSON.parse(localStorage.getItem('businessPin')) || ''
            let businessEmail = JSON.parse(localStorage.getItem('businessEmail')) || ''
            let businessSCU = JSON.parse(localStorage.getItem('businessSCU')) || ''
            let businessPhone = JSON.parse(localStorage.getItem('businessPhone')) || ''

            console.log(businessName, businessPin, businessEmail, businessSCU, businessPhone)

            // Map items
            const items = this.selectedSale.items.map(item => ({
                id: item.id,
                name: item.itemNm,
                qty: Number(item.qty),
                price: Number(item.prc),
                amount: Number(item.totAmt)
            }));

            // Prepare invoice data
            const invoiceData = {
                shopName: businessName,
                phone: businessPhone,
                pin: businessPin,
                email: businessEmail,
                invoiceTitle: "Customer Invoice",
                date: this.formatDate(new Date()),
                invoiceNumber: this.selectedSale.invcNo,
                billNo: this.selectedSale.trdInvcNo,
                time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
                printDate: this.formatDate(new Date()),
                customer: this.selectedSale.custNm,
                customerTin: this.selectedSale.custTin,
                items: items,
                receiptSign: this.selectedSale.rcptSign,
                internalData: this.selectedSale.intrlData,
                taxable: this.selectedSale.totTaxblAmt,
                total: this.selectedSale.totAmt,
                totalTaxAmount: this.selectedSale.totTaxAmt,
                scuId: businessSCU,
                qrData: this.getEtimsLink()
            };

            // Generate and download invoice
            const invoiceHTML = this.createGeneralInvoice(invoiceData);
            this.downloadInvoice(invoiceHTML, `Invoice_${invoiceData.invoiceNumber}.html`);
        },



        createGeneralInvoice(data) {
        const totalAmount = Number(data.total) || 0;
        const qrCodeDataUrl = this.generateQRCode(data.qrData);
        
        return `
        <!DOCTYPE html>
        <html>
        <head>
            <meta charset="utf-8">
            <title>Invoice ${data.invoiceNumber}</title>
            <style>
                /* Reset CSS */
                * {
                    margin: 0;
                    padding: 0;
                    box-sizing: border-box;
                }

                /* Print-specific styles */
                @media print {
                    body {
                        -webkit-print-color-adjust: exact !important;
                        print-color-adjust: exact !important;
                    }
                    
                    @page {
                        size: A4;
                        margin: 15mm;
                    }
                }

                body {
                    font-family: Arial, sans-serif;
                    line-height: 1.3;
                    color: #000;
                    background: #fff;
                }

                .invoice-container {
                    width: 210mm;
                    min-height: 297mm;
                    padding: 20mm;
                    margin: 0 auto;
                    background: white;
                }

                .invoice-header {
                    background-color: #87CEEB !important;
                    color: black;
                    text-align: center;
                    padding: 10px;
                    margin-bottom: 20px;
                    font-weight: bold;
                    font-size: 18px;
                    border-radius: 4px;
                }

                .info-section {
                    display: flex;
                    justify-content: space-between;
                    gap: 20px;
                    margin-bottom: 20px;
                }

                .info-box {
                    flex: 1;
                    border: 1px solid black;
                    padding: 15px;
                    border-radius: 4px;
                }

                .info-box p {
                    margin: 5px 0;
                    font-size: 12px;
                    line-height: 1.4;
                }

                .details-section {
                    border: 1px solid black;
                    padding: 15px;
                    margin-bottom: 20px;
                    border-radius: 4px;
                }

                .details-grid {
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                    gap: 10px;
                }

                .details-grid p {
                    margin: 5px 0;
                    font-size: 12px;
                }

                .items-table {
                    width: 100%;
                    border-collapse: collapse;
                    margin: 20px 0;
                    page-break-inside: auto;
                }

                .items-table tr {
                    page-break-inside: avoid;
                    page-break-after: auto;
                }

                .items-table th, 
                .items-table td {
                    border: 1px solid black;
                    padding: 8px;
                    text-align: left;
                    font-size: 12px;
                }

                .items-table th {
                    background-color: #ffffff;
                    font-weight: bold;
                }

                .totals-section {
                    text-align: right;
                    margin-top: 20px;
                    page-break-inside: avoid;
                }

                .totals-section p {
                    margin: 5px 0;
                    font-size: 12px;
                }

                .signature-section {
                    display: flex;
                    justify-content: space-between;
                    margin-top: 40px;
                    page-break-inside: avoid;
                }

                .signature-box {
                    width: 45%;
                }

                .signature-box p {
                    font-size: 12px;
                    margin-bottom: 5px;
                }

                .signature-line {
                    border-top: 1px solid black;
                    width: 80%;
                    margin-top: 40px;
                }

                /* Ensure proper page breaks */
                .page-break {
                    page-break-after: always;
                }

                /* Prevent unwanted breaks */
                .no-break {
                    page-break-inside: avoid;
                }
                
                .qr-section {
                    display: flex;
                    align-items: flex-start;
                    justify-content: flex-start;
                    margin: 20px 0;
                    padding: 15px;
                    border: 1px solid black;
                    border-radius: 4px;
                    page-break-inside: avoid;
                }

                .qr-code-container {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    margin-right: 20px;
                }

                .qr-section img {
                    width: 100px;
                    height: 100px;
                    border: 1px solid #ddd;
                    padding: 5px;
                }

                .qr-details {
                    flex: 1;
                }

                .qr-details p {
                    margin: 5px 0;
                    font-size: 12px;
                    line-height: 1.4;
                }

                .qr-details strong {
                    font-weight: bold;
                }
            
                .etims-footer {
                        margin-top: 15px;
                        padding-top: 8px;
                        border-top: 1px solid #ddd;
                        text-align: center;
                        font-size: 11px;
                        color: #666;
                        font-style: italic;
                    }
            
            </style>
        </head>
        <body>
            <div class="invoice-container">
                <div class="invoice-header">
                    Customer Invoice
                </div>
                
                <div class="info-section">  
                    <div class="info-box">
                        <p><strong>${data.shopName}</strong></p>
                        <p>Phone: ${data.phone}</p>
                        <p>Pin: ${data.pin}</p>
                        <p>Email: ${data.email}</p>
                    </div>
                    <div class="info-box">
                        <p><strong>Client Name:</strong> ${data.customer || ''}</p>
                        <p><strong>Client Pin:</strong> ${data.customerTin || ''}</p>
                    </div>
                </div>

                <div class="details-section">
                    <div class="details-grid">
                        <p><strong>Invoice No:</strong> ${data.invoiceNumber}</p>
                        <p><strong>Bill No:</strong> ${data.billNo}</p>
                        <p><strong>Created On:</strong> ${data.date}</p>
                        <p><strong>Due Date:</strong> ${data.printDate}</p>
                    </div>
                </div>

                <table class="items-table">
                    <thead>
                        <tr>
                            <th>No</th>
                            <th>Item</th>
                            <th>Quantity</th>
                            <th>Rate</th>
                            <th>Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${data.items.map((item, index) => `
                            <tr>
                                <td>${index + 1}</td>
                                <td>${item.name}</td>
                                <td>${item.qty}</td>
                                <td>${(item.price || 0).toFixed(2)}</td>
                                <td>${(item.amount || 0).toFixed(2)}</td>
                            </tr>
                        `).join('')}
                    </tbody>
                </table>

                <div class="totals-section">
                    <p><strong>Total:</strong> ${totalAmount.toFixed(2)}</p>
                    <p><strong>Discount:</strong> 0.00</p>
                    <p><strong>Credit Note:</strong> 0.00</p>
                    <p><strong>Balance:</strong> ${totalAmount.toFixed(2)}</p>
                </div>

                <div class="qr-section">
                <div class="qr-code-container">
                    <img src="${qrCodeDataUrl}" alt="QR Code"/>
                </div>
                <div class="qr-details">
                    <p><strong>Receipt Signature:</strong> ${data.receiptSign || 'N/A'}</p>
                    <p><strong>Internal Data:</strong> ${data.internalData || 'N/A'}</p>
                    <p><strong>SCU ID:</strong> ${data.scuId}</p>
                    <p><strong>SCU Invoice No:</strong> ${data.scuId}/${data.invoiceNumber}</p>
                </div>
            </div>

                <div class="signature-section">
                    <div class="signature-box">
                        <p>Prepared by: ${data.preparedBy || ''}</p>
                        <div class="signature-line"></div>
                    </div>
                    <div class="signature-box">
                        <p>Customer</p>
                        <div class="signature-line"></div>
                    </div>
                </div>
                <p class="etims-footer">eTIMS Invoice generated by Stanbest Group EA LTD</p>
            </div>
        </body>
        
        </html>`;
    },


    generatePurchaseInvoice() {
        const data = {
            invoiceNumber: 2,
            billNo: 2,
            date: '12/09/2025 - 11:23',
            printDate: '12/09/2025 - 11:23',
            shopName: 'GA INSURANCE LTD',
            phone: '0709626000',
            pin: 'P000612829R',
            email: 'insure@gakenya.com',
            customer: 'CSL SERVICES LIMITED',
            customerTin: 'P051905681V',
            customerInvoice: '135',
            scuId: 'KRACU0300000142',
            total: 7161560,
            items: [
                {
                    name: 'Medical Claim Costs July 2025',
                    qty: 1,
                    price: 7161560,
                    amount: 7161560
                }
            ],
            qrData: 'Invoice No: 3, PIN: P051905681V, Amount: 7,161,560',
            preparedBy: 'System'
        };

        const html = this.createPurchaseInvoice(data);
        this.downloadInvoice(html, 'purchase_invoice_ga_insurance.html');
    },


    createPurchaseInvoice(data) {

        const totalAmount = Number(data.total) || 0;
        const qrCodeDataUrl = this.generateQRCode(data.qrData);


        return `
        <!DOCTYPE html>
        <html>
        <head>
            <meta charset="utf-8">
            <title>Invoice ${data.invoiceNumber}</title>
            <style>
                /* Reset CSS */
                * {
                    margin: 0;
                    padding: 0;
                    box-sizing: border-box;
                }

                /* Print-specific styles */
                @media print {
                    body {
                        -webkit-print-color-adjust: exact !important;
                        print-color-adjust: exact !important;
                    }
                    
                    @page {
                        size: A4;
                        margin: 15mm;
                    }
                }

                body {
                    font-family: Arial, sans-serif;
                    line-height: 1.3;
                    color: #000;
                    background: #fff;
                }

                .invoice-container {
                    width: 210mm;
                    min-height: 297mm;
                    padding: 20mm;
                    margin: 0 auto;
                    background: white;
                }

                .invoice-header {
                    background-color: #87CEEB !important;
                    color: black;
                    text-align: center;
                    padding: 10px;
                    margin-bottom: 20px;
                    font-weight: bold;
                    font-size: 18px;
                    border-radius: 4px;
                }

                .info-section {
                    display: flex;
                    justify-content: space-between;
                    gap: 20px;
                    margin-bottom: 20px;
                }

                .info-box {
                    flex: 1;
                    border: 1px solid black;
                    padding: 15px;
                    border-radius: 4px;
                }

                .info-box p {
                    margin: 5px 0;
                    font-size: 12px;
                    line-height: 1.4;
                }

                .details-section {
                    border: 1px solid black;
                    padding: 15px;
                    margin-bottom: 20px;
                    border-radius: 4px;
                }

                .details-grid {
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                    gap: 10px;
                }

                .details-grid p {
                    margin: 5px 0;
                    font-size: 12px;
                }

                .items-table {
                    width: 100%;
                    border-collapse: collapse;
                    margin: 20px 0;
                    page-break-inside: auto;
                }

                .items-table tr {
                    page-break-inside: avoid;
                    page-break-after: auto;
                }

                .items-table th, 
                .items-table td {
                    border: 1px solid black;
                    padding: 8px;
                    text-align: left;
                    font-size: 12px;
                }

                .items-table th {
                    background-color: #ffffff;
                    font-weight: bold;
                }

                .totals-section {
                    text-align: right;
                    margin-top: 20px;
                    page-break-inside: avoid;
                }

                .totals-section p {
                    margin: 5px 0;
                    font-size: 12px;
                }

                .signature-section {
                    display: flex;
                    justify-content: space-between;
                    margin-top: 40px;
                    page-break-inside: avoid;
                }

                .signature-box {
                    width: 45%;
                }

                .signature-box p {
                    font-size: 12px;
                    margin-bottom: 5px;
                }

                .signature-line {
                    border-top: 1px solid black;
                    width: 80%;
                    margin-top: 40px;
                }

                /* Ensure proper page breaks */
                .page-break {
                    page-break-after: always;
                }

                /* Prevent unwanted breaks */
                .no-break {
                    page-break-inside: avoid;
                }
                
                .qr-section {
                    display: flex;
                    align-items: flex-start;
                    justify-content: flex-start;
                    margin: 20px 0;
                    padding: 15px;
                    border: 1px solid black;
                    border-radius: 4px;
                    page-break-inside: avoid;
                }

                .qr-code-container {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    margin-right: 20px;
                }

                .qr-section img {
                    width: 100px;
                    height: 100px;
                    border: 1px solid #ddd;
                    padding: 5px;
                }

                .qr-details {
                    flex: 1;
                }

                .qr-details p {
                    margin: 5px 0;
                    font-size: 12px;
                    line-height: 1.4;
                }

                .qr-details strong {
                    font-weight: bold;
                }
            
                .etims-footer {
                        margin-top: 15px;
                        padding-top: 8px;
                        border-top: 1px solid #ddd;
                        text-align: center;
                        font-size: 11px;
                        color: #666;
                        font-style: italic;
                    }
            
            </style>
        </head>
        <body>
            <div class="invoice-container">
                <div class="invoice-header">
                    Purchase Invoice
                </div>
                
                <div class="info-section">  
                    <div class="info-box">
                        <p><strong>${data.shopName}</strong></p>
                        <p>Phone: ${data.phone}</p>
                        <p>Pin: ${data.pin}</p>
                        <p>Email: ${data.email}</p>
                    </div>
                    <div class="info-box">
                        <p><strong>Supplier Name:</strong> ${data.customer}</p>
                        <p><strong>Supplier Pin:</strong> ${data.customerTin}</p>
                        <p><strong>Supplier Invoice:</strong> ${data.customerInvoice}</p>
                    </div>
                </div>

                <div class="details-section">
                    <div class="details-grid">
                        <p><strong>Invoice No:</strong> ${data.invoiceNumber}</p>
                        <p><strong>Bill No:</strong> ${data.billNo}</p>
                        <p><strong>Created On:</strong> ${data.date}</p>
                        <p><strong>Due Date:</strong> ${data.printDate}</p>
                    </div>
                </div>

                <table class="items-table">
                    <thead>
                        <tr>
                            <th>No</th>
                            <th>Item</th>
                            <th>Quantity</th>
                            <th>Rate</th>
                            <th>Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${data.items.map((item, index) => `
                            <tr>
                                <td>${index + 1}</td>
                                <td>${item.name}</td>
                                <td>${item.qty}</td>
                                <td>${item.price.toFixed(2)}</td>
                                <td>${item.amount.toFixed(2)}</td>
                            </tr>
                        `).join('')}
                    </tbody>
                </table>

                <div class="totals-section">
                    <p><strong>Total:</strong> ${totalAmount.toFixed(2)}</p>
                    <p><strong>Balance:</strong> ${totalAmount.toFixed(2)}</p>
                </div>

                <div class="qr-section">
                    <div class="qr-code-container">
                        <img src="${qrCodeDataUrl}" alt="QR Code"/>
                    </div>
                    <div class="qr-details">
                        <p><strong>SCU ID:</strong> ${data.scuId}</p>
                        <p><strong>SCU Invoice No:</strong> ${data.scuId}/${data.invoiceNumber}</p>
                    </div>
                </div>

                <div class="signature-section">
                    <div class="signature-box">
                        <p>Prepared by: ${data.preparedBy}</p>
                        <div class="signature-line"></div>
                    </div>
                    <div class="signature-box">
                        <p>Customer</p>
                        <div class="signature-line"></div>
                    </div>
                </div>

                <p class="etims-footer">eTIMS Invoice generated by Stanbest Group EA LTD</p>
            </div>
        </body>
        </html>`;
    },


    generateCKInvoice() {
        // Validate sale data
        if (!this.selectedSale || !Array.isArray(this.selectedSale.items)) {
            console.error("Sale data is not available or items are not defined.");
            return;
        }

        // Get business details from localStorage
        let businessName = JSON.parse(localStorage.getItem('businessName')) || '';
        let businessPin = JSON.parse(localStorage.getItem('businessPin')) || '';
        let businessSCU = JSON.parse(localStorage.getItem('businessSCU')) || '';
        let businessEmail = JSON.parse(localStorage.getItem('businessEmail')).toLowerCase() || '';
        let businessPhone = JSON.parse(localStorage.getItem('businessPhone')) || '';

        // Map items
        const items = this.selectedSale.items.map(item => ({
            id: item.id,
            name: item.itemNm,
            qty: Number(item.qty),
            price: Number(item.prc),
            amount: Number(item.totAmt)
        }));

        // Calculate total and VAT amounts
        // const netTotal = Number(this.selectedSale.totTaxblAmt || 0).toFixed(2);
        // const vatRate = 16;
        // const vatAmount = Number(this.selectedSale.totTaxAmt || 0).toFixed(2);
        // const grandTotal = Number(this.selectedSale.totAmt || 0).toFixed(2);

        const netTotal = Number(this.selectedSale.totTaxblAmt || 0);
        const vatRate = 16;
        const vatAmount = Number(this.selectedSale.totTaxAmt || 0);
        const grandTotal = Number(this.selectedSale.totAmt || 0);


        // Format dates
        const invoiceDate = this.formatDate(new Date());
        const dueDate = this.formatDueDate(new Date(), 14); // 14 days payment term
        
        // Prepare invoice data
        const invoiceData = {
            businessName: businessName,
            businessAddress: 'P. O. BOX 107 – 20100 NAKURU ',
            businessPhone: businessPhone,
            businessEmail: businessEmail,
            businessPin: businessPin,
            businessVAT: '16%',
            businessAccountDetails: 'ACCOUNT NO: 3000086445, PRIME BANK LTD NAKURU BRANCH, BANK-BRANCH CODE: 10-017, SWIFT CODE: PRIEKENX',
            
            invoiceNumber: this.selectedSale.invcNo,
            invoiceDate: invoiceDate,
            dueDate: dueDate,
            currentTime: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' }),
            
            customerName: this.selectedSale.custNm,
            customerAddress: this.selectedSale.custAddr || '',
            customerAccount: this.selectedSale.custAcct || '',
            customerPin: this.selectedSale.custTin,
            customerExemptId: this.selectedSale.custExempt || '',
            receiptSign: this.selectedSale.rcptSign,
            internalData: this.selectedSale.intrlData,

            
            items: items,
            netTotal: netTotal,
            vatRate: vatRate,
            vatAmount: vatAmount,
            grandTotal: grandTotal,
            
            scuId: businessSCU || '',
            qrData: this.getEtimsLink()
        };

        // Generate and download invoice
        const invoiceHTML = this.createCKInvoiceHTML(invoiceData);
        this.downloadInvoice(invoiceHTML, `TaxInvoice_${invoiceData.invoiceNumber}.html`);
    },

    formatDueDate(date, daysToAdd) {
        const dueDate = new Date(date);
        dueDate.setDate(dueDate.getDate() + daysToAdd);
        return this.formatDate(dueDate);
    },

    createCKInvoiceHTML(data) {
        const qrCodeDataUrl = this.generateQRCode(data.qrData);
        
        return `
        <!DOCTYPE html>
        <html>
        <head>
            <meta charset="utf-8">
            <title>Tax Invoice ${data.invoiceNumber}</title>
            <style>
                /* Reset CSS */
                * {
                    margin: 0;
                    padding: 0;
                    box-sizing: border-box;
                }

                /* Print-specific styles */
                @media print {
                    body {
                        -webkit-print-color-adjust: exact !important;
                        print-color-adjust: exact !important;
                    }
                    
                    @page {
                        size: A4;
                        margin: 15mm;
                    }
                }

                body {
                    font-family: Arial, sans-serif;
                    line-height: 1.3;
                    color: #000;
                    background: #fff;
                }

                .invoice-container {
                    width: 210mm;
                    min-height: 297mm;
                    padding: 20mm;
                    margin: 0 auto;
                    background: white;
                }

                .header-container {
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-start;
                    margin-bottom: 15px;
                }

                .company-header {
                    text-align: left;
                    margin-bottom: 15px;
                    font-size: 24px;
                    font-weight: bold;
                    color: #0066cc; /* Blue color for the company name */
                }

                .company-address {
                    text-align: right;
                    font-size: 12px;
                    line-height: 1.4;
                    color: #0066cc;
                }

                .invoice-header {
                    text-align: left;
                    margin-top: 5px;
                    margin-bottom: 20px;
                    font-weight: bold;
                    font-size: 16px;
                    color: #000000; /* Explicitly set to black */
                }

                .customer-section {
                    margin-bottom: 20px;
                }

                .customer-section p {
                    margin: 2px 0;
                    font-size: 12px;
                    line-height: 1.4;
                }

                .invoice-details {
                    text-align: right;
                    margin-bottom: 20px;
                }

                .invoice-details p {
                    margin: 2px 0;
                    font-size: 12px;
                    line-height: 1.4;
                }

                .items-table {
                    width: 100%;
                    border-collapse: collapse;
                    margin: 20px 0;
                    page-break-inside: auto;
                }

                .items-table tr {
                    page-break-inside: avoid;
                    page-break-after: auto;
                }

                .items-table th, 
                .items-table td {
                    border: 1px solid black;
                    padding: 8px;
                    text-align: left;
                    font-size: 12px;
                }

                .items-table th {
                    background-color: #f2f2f2;
                    font-weight: bold;
                }

                .items-table td.amount {
                    text-align: right;
                }

                .items-table td:nth-child(4), 
                .items-table th:nth-child(4) {
                    width: 100px; /* RATE */
                }

                .items-table td:nth-child(5), 
                .items-table th:nth-child(5) {
                    width: 120px; /* NET TOTAL */
                }

                .items-table td:nth-child(6), 
                .items-table th:nth-child(6) {
                    width: 60px; /* VAT RATE - reduced */
                }


                .totals-section {
                    border: 1px solid black;
                    padding: 10px;
                    margin-top: 10px;
                    page-break-inside: avoid;
                }

                .tax-summary {
                    font-weight: bold;
                    margin-bottom: 10px;
                }

                .totals {
                    text-align: right;
                }

                .totals p {
                    margin: 5px 0;
                    font-size: 12px;
                }

                .payment-instructions {
                    margin-top: 20px;
                    padding: 10px;
                    font-size: 12px;
                    border-top: 1px solid #ddd;
                    page-break-inside: avoid;
                }

                .company-footer {
                    margin-top: 15px;
                    font-size: 11px;
                    text-align: center;
                }

                .qr-section {
                    display: flex;
                    align-items: flex-start;
                    justify-content: flex-start;
                    margin: 20px 0;
                    padding: 15px;
                    border: 1px solid black;
                    border-radius: 4px;
                    page-break-inside: avoid;
                }

                .qr-code-container {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    margin-right: 20px;
                }

                .qr-section img {
                    width: 100px;
                    height: 100px;
                    border: 1px solid #ddd;
                    padding: 5px;
                }

                .qr-details {
                    flex: 1;
                }

                .qr-details p {
                    margin: 5px 0;
                    font-size: 12px;
                    line-height: 1.4;
                }

                .qr-details strong {
                    font-weight: bold;
                }
                
                .etims-footer {
                    margin-top: 15px;
                    padding-top: 8px;
                    border-top: 1px solid #ddd;
                    text-align: center;
                    font-size: 11px;
                    color: #666;
                    font-style: italic;
                }

                .timestamp {
                    font-size: 10px;
                    text-align: center;
                    margin-top: 10px;
                }
            </style>
        </head>
        <body>
            <div class="invoice-container">
                <div class="header-container">
                    <div class="company-header">
                         C. K. Patel Limited
                        <div class="invoice-header">
                            TAX INVOICE
                        </div>
                    </div>
                    <div class="company-address">
                        ${data.businessAddress}<br>
                        TEL: ${data.businessPhone}<br>
                        EMAIL: ${data.businessEmail}<br>
                        PIN NO. ${data.businessPin}
                    </div>
                </div>
                
                <div style="display: flex; justify-content: space-between;">
                    <div class="customer-section">
                        <p><strong>CUSTOMER NAME:</strong></p>
                        <p>${data.customerName}</p>
                        <p>${data.customerAddress}</p>
                        <p>CUSTOMER PIN: ${data.customerPin}</p>
                    </div>
                    
                    <div class="invoice-details">
                        <p><strong>INVOICE DATE:</strong> ${data.invoiceDate}</p>
                        <p><strong>INVOICE NO:</strong> ${data.scuId}/${data.invoiceNumber}</p>
                        <p><strong>DATE DUE:</strong> ${data.dueDate}</p>
                    </div>
                </div>

                <!-- Items Table -->
                <table class="items-table">
                    <thead>
                        <tr>
                            <th>No</th>
                            <th>ITEM</th>
                            <th>QTY</th>
                            <th>RATE</th>
                            <th>Net Total</th>
                            <th>VAT RATE</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${data.items.map((item, index) => `
                            <tr>
                                <td>${index + 1}</td>
                                <td>${item.name}</td>
                                <td>${item.qty}</td>
                                <td class="amount">${(item.price || 0).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}</td>
                                <td class="amount">${(item.qty * item.price || 0).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}</td>
                                <td>${data.vatRate}%</td>
                            </tr>
                        `).join('')}
                    </tbody>
                </table>

                <div class="totals-section">
                    <div class="tax-summary">TAX SUMMARY</div>
                    <div class="totals">
                        <p>NET Total: Kshs ${data.netTotal.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}</p>
                        <p>VAT Total ${data.vatRate}%: Kshs  ${data.vatAmount.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}</p>
                        <p>GRAND TOTAL: Kshs ${data.grandTotal.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}</p>
                    </div>
                </div>

                <div class="qr-section">
                    <div class="qr-code-container">
                        <img src="${qrCodeDataUrl}" alt="QR Code"/>
                    </div>
                    <div class="qr-details">
                        <p><strong>Receipt Signature:</strong> ${data.receiptSign || 'N/A'}</p>
                        <p><strong>Internal Data:</strong> ${data.internalData || 'N/A'}</p>
                        <p><strong>SCU ID:</strong> ${data.scuId}</p>
                        <p><strong>SCU Invoice No:</strong> ${data.scuId}/${data.invoiceNumber}</p>
                    </div>
                </div>

                <p class="etims-footer">eTIMS Invoice generated by Stanbest Group EA LTD</p>

                <div class="timestamp">
                    ${data.scuId}/${data.invoiceNumber} ${data.invoiceDate} ${data.currentTime}
                </div>
            </div>
        </body>
        </html>`;
    },


    downloadInvoice(html, filename) {
      const blob = new Blob([html], { type: 'text/html' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

   

    
        //INVOICE
        //
        //
        //
    },
    mounted(){
        // this.dataAccess()
        this.getCodes()
      
    },
    watch: {
        'sale.items': {
            handler(newItems) {
                newItems.forEach((item, index) => {
                    let priceChange = item.prc * item.qty;
                    this.sale.items[index].totAmt = priceChange;
                });
            },
            deep: true
        }
    },
})
</script>


<style scoped>

.ant-table-wrapper {
    /* display: flex;
    justify-content: center;
    align-items: center;  */
    margin:0 auto;
    width: 90vw;
}
.ant-table, .ant-table-content {
    width: 90vw;
    margin:0 auto;    
}



.modal {
  display: block; 
  position: fixed; 
  z-index: 99; 
  padding-top: 100px; 
  left: 0;
  top: 0;
  width: 100%; 
  height: 100%; 
  overflow: auto; 
  background-color: rgb(0,0,0); 
  background-color: rgba(0,0,0,0.4); 
}

.card {
    font-family: Roboto, sans-serif;
    font-size: 14px;
    width: 90vw;
    margin-left: auto;
    margin-right: auto;

}

.modal-content {
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}

.close {
  color: #aaaaaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}

.modal {
    font-family: Roboto, sans-serif;
}

.table:not(.macho) {
    font-family: Roboto, sans-serif;
    font-size: 14px;
    width: 90vw;
    margin-left: auto;
    margin-right: auto;
}

.sales-header {
    width: 90vw;
    margin-left: auto;
    margin-right: auto;
    font-family: Roboto, sans-serif;
}

.p-datatable {
  border-collapse: collapse;
}

.p-datatable .p-datatable-tbody > tr > td {
  border: 1px solid #dee2e6;
}
.v-field-label {
    font-family: Roboto, sans-serif !important;
}

.account-details {
    margin: 20px 0;
    padding: 15px;
    border: 1px solid #ddd;
    border-radius: 4px;
    background-color: #f8f9fa;
}

.details-row {
    display: table;
    width: 100%;
    table-layout: fixed;
    border-collapse: separate;
    border-spacing: 10px;
}

.details-column {
    display: table-cell;
    width: 50%;
    padding: 10px;
    vertical-align: top;
    background-color: white;
    border-radius: 4px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.details-column h3 {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 10px;
    color: #333;
    padding-bottom: 5px;
    border-bottom: 1px solid #eee;
}

.details-column p {
    font-size: 13px;
    margin: 5px 0;
    color: #444;
}

.control-note {
    margin-top: 15px;
    text-align: center;
    font-weight: bold;
    font-size: 12px;
    padding-top: 10px;
    border-top: 1px solid #ddd;
}

.control-note p {
    margin: 0;
}
</style>
